(function ($) {
  var queryParser = function (a) {
      var i, p, b = {};
      if (a === "") {
        return {};
      }
      for (i = 0; i < a.length; i += 1) {
        p = a[i].split('=');
        if (p.length === 2) {
          b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
        }
      }
      return b;
    };
  $.queryParams = function () {
    return queryParser(window.location.search.substr(1).split('&'));
  };
  $.hashParams = function () {
    return queryParser(window.location.hash.substr(1).split('&'));
  };


  var ident = 0;

  window.Swiftype = window.Swiftype || {};
  Swiftype.root_url = Swiftype.root_url || 'https://api.swiftype.com';
  Swiftype.pingUrl = function(endpoint, callback) {
    var to = setTimeout(callback, 350);
    var img = new Image();
    img.onload = img.onerror = function() {
      clearTimeout(to);
      callback();
    };
    img.src = endpoint;
    return false;
  };
  Swiftype.pingAutoSelection = function(engineKey, docId, value, callback) {
    var params = {
      t: new Date().getTime(),
      engine_key: engineKey,
      doc_id: docId,
      prefix: value
    };
    var url = Swiftype.root_url + '/api/v1/public/analytics/pas?' + $.param(params);
    Swiftype.pingUrl(url, callback);
  };
  Swiftype.findSelectedSection = function() {
    var sectionText = $.hashParams().sts;
    if (!sectionText) { return; }

    function normalizeText(str) {
      var out = str.replace(/\s+/g, '');
      out = out.toLowerCase();
      return out;
    }

    sectionText = normalizeText(sectionText);

    $('h1, h2, h3, h4, h5, h6').each(function(idx) {
      $this = $(this);
      if (normalizeText($this.text()).indexOf(sectionText) >= 0) {
        this.scrollIntoView(true);
        return false;
      }
    });
  };

  Swiftype.htmlEscape = Swiftype.htmlEscape || function htmlEscape(str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };

  $.fn.swiftype = function (options) {
    Swiftype.findSelectedSection();
    var options = $.extend({}, $.fn.swiftype.defaults, options);

    return this.each(function () {
      var $this = $(this);
      var config = $.meta ? $.extend({}, options, $this.data()) : options;
      $this.attr('autocomplete', 'off');
      $this.data('swiftype-config-autocomplete', config);
      $this.submitted = false;
      $this.cache = new LRUCache(10);
      $this.emptyQueries = [];

      $this.isEmpty = function(query) {
        return $.inArray(normalize(query), this.emptyQueries) >= 0
      };

      $this.addEmpty = function(query) {
        $this.emptyQueries.unshift(normalize(query));
      };

      var styles = config.dropdownStylesFunction($this);
      var $swiftypeWidget = $('<div class="' + config.widgetContainerClass + '" />');
      var $listContainer = $('<div />').addClass(config.suggestionListClass).appendTo($swiftypeWidget).css(styles).hide();
      $swiftypeWidget.appendTo(config.autocompleteContainingElement);
      var $list = $('<' + config.suggestionListType + ' />').appendTo($listContainer);

      $this.data('swiftype-list', $list);

      $this.abortCurrent = function() {
        if ($this.currentRequest) {
          $this.currentRequest.abort();
        }
      };

      $this.showList = function() {
        if (handleFunctionParam(config.disableAutocomplete) === false) {
          $listContainer.show();
          if (!this[0].id.includes('footer')) {
            $('body').css('overflow-y','hidden');
            $('html').css('overflow-y','hidden');
            $('body').css('position','relative');
            $('html').css('position','relative');
          }          
        }
      };

      $this.hideList = function(sync) {
        if (sync) {
          $listContainer.hide();
        } else {
          setTimeout(function() { $listContainer.hide(); }, 10);
        }
        if (!this[0].id.includes('footer')) {
          $('body').css('overflow-y','inherit');
          $('html').css('overflow-y','inherit');
        }        
      };

      $this.showNoResults = function () {
        $list.empty();
        if (config.noResultsMessage === undefined) {
          $this.hideList();
        } else {
          $list.append($('<li />', { 'class': config.noResultsClass }).text(config.noResultsMessage));
          $this.showList();
        }
      };

      $this.focused = function() {
        return $this.is(':focus');
      };

      $this.submitting = function() {
        $this.submitted = true;
      };

      $this.listResults = function() {
        return $(config.resultListSelector, $list).filter(':not(.' + config.noResultsClass + ')');
      };

      $this.activeResult = function() {
        return $this.listResults().filter('.' + config.activeItemClass).first();
      };

      $this.prevResult = function() {
        var list = $this.listResults(),
          currentIdx = list.index($this.activeResult()),
          nextIdx = currentIdx - 1,
          next = list.eq(nextIdx);
        $this.listResults().removeClass(config.activeItemClass);
        if (nextIdx >= 0) {
          next.addClass(config.activeItemClass);
        }
      };

      $this.nextResult = function() {
        var list = $this.listResults(),
          currentIdx = list.index($this.activeResult()),
          nextIdx = currentIdx + 1,
          next = list.eq(nextIdx);
        $this.listResults().removeClass(config.activeItemClass);
        if (nextIdx >= 0) {
          next.addClass(config.activeItemClass);
        }
      };

      $this.selectedCallback = function(data) {
        return function() {
          var value = $this.val(),
            callback = function() {
              config.onComplete(data, value);
            };
          Swiftype.pingAutoSelection(config.engineKey, data['id'], value, callback);
        };
      };

      $this.registerResult = function($element, data) {
        $element.data('swiftype-item', data);
        $element.click($this.selectedCallback(data)).mouseover(function () {
          $this.listResults().removeClass(config.activeItemClass);
          $element.addClass(config.activeItemClass);
        });
      };

      $this.getContext = function() {
        return {
          config: config,
          list: $list,
          registerResult: $this.registerResult
        };
      };


      var typingDelayPointer;
      var suppressKey = false;
      $this.lastValue = '';
      $this.keyup(function (event) {
        if (suppressKey) {
          suppressKey = false;
          return;
        }

        // ignore arrow keys, shift
        if (((event.which > 36) && (event.which < 41)) || (event.which == 16)) return;

        if (config.typingDelay > 0) {
          clearTimeout(typingDelayPointer);
          typingDelayPointer = setTimeout(function () {
            processInput($this);
          }, config.typingDelay);
        } else {
          processInput($this);
        }
      });

      $this.styleDropdown = function() {
        $listContainer.css(config.dropdownStylesFunction($this));
      };

      $(window).resize(function (event) {
        $this.styleDropdown();
      });

      $this.keydown(function (event) {
        $this.styleDropdown();
        // enter = 13; up = 38; down = 40; esc = 27
        var $active = $this.activeResult();
        switch (event.which) {
        case 13:
          if (($active.length !== 0) && ($list.is(':visible'))) {
            event.preventDefault();
            $this.selectedCallback($active.data('swiftype-item'))();
          } else if ($this.currentRequest) {
            $this.submitting();
          }
          $this.hideList();
          suppressKey = true;
          break;
        case 38:
          event.preventDefault();
          if ($active.length === 0) {
            $this.listResults().last().addClass(config.activeItemClass);
          } else {
            $this.prevResult();
          }
          break;
        case 40:
          event.preventDefault();
          if ($active.length === 0) {
            $this.listResults().first().addClass(config.activeItemClass);
          } else if ($active != $this.listResults().last()) {
            $this.nextResult();
          }
          break;
        case 27:
          $this.hideList();
          suppressKey = true;
          break;
        default:
          $this.submitted = false;
          break;
        }
      });

      // opera wants keypress rather than keydown to prevent the form submit
      $this.keypress(function (event) {
        if ((event.which == 13) && ($this.activeResult().length > 0)) {
          event.preventDefault();
        }
      });

      // stupid hack to get around loss of focus on mousedown
      var mouseDown = false;
      var blurWait = false;
      $(document).bind('mousedown.swiftype' + ++ident, function () {
        mouseDown = true;
      });
      $(document).bind('mouseup.swiftype' + ident, function () {
        mouseDown = false;
        if (blurWait) {
          blurWait = false;
          $this.hideList();
        }
      });
      $this.blur(function () {
        if (mouseDown) {
          blurWait = true;
        } else {
          $this.hideList();
        }
      });
      /* This code was causing a browser crash for mobile users anytime they clicked a form field
      $this.focus(function () {
        setTimeout(function() { $this.select() }, 10);
        if ($this.listResults().length > 0) {
          $this.showList();
        }
      });*/
    });
  };

  var normalize = function(str) {
    return $.trim(str).toLowerCase();
  };

  var callRemote = function ($this, term) {
    $this.abortCurrent();

    var params = {},
      config = $this.data('swiftype-config-autocomplete');

    params['q'] = term;
    params['engine_key'] = config.engineKey;
    params['search_fields'] = handleFunctionParam(config.searchFields);
    params['fetch_fields'] = handleFunctionParam(config.fetchFields);
    params['filters'] = handleFunctionParam(config.filters);
    params['document_types'] = handleFunctionParam(config.documentTypes);
    params['functional_boosts'] = handleFunctionParam(config.functionalBoosts);
    params['sort_field'] = handleFunctionParam(config.sortField);
    params['sort_direction'] = handleFunctionParam(config.sortDirection);
    params['per_page'] = config.resultLimit;
    params['highlight_fields'] = config.highlightFields;

    var endpoint = Swiftype.root_url + '/api/v1/public/engines/suggest.json';
    $this.currentRequest = $.ajax({
      type: 'GET',
      dataType: 'jsonp',
      url: endpoint,
      data: params
    }).done(function(data) {
      var norm = normalize(term);
      if (data.record_count > 0) {
        $this.cache.put(norm, data.records);
      } else {
        $this.addEmpty(norm);
        $this.showNoResults();
        return;
      }
      processData($this, data.records, term);
    });
  };

  var getResults = function($this, term) {
    var norm = normalize(term);
    if ($this.isEmpty(norm)) {
      $this.showNoResults();
      return;
    }
    var cached = $this.cache.get(norm);
    if (cached) {
      processData($this, cached, term);
    } else {
      callRemote($this, term);
    }
  };

  // private helpers
  var processInput = function ($this) {
      var term = $this.val();
      if (term === $this.lastValue) {
        return;
      }
      $this.lastValue = term;
      if ($.trim(term) === '') {
        $this.data('swiftype-list').empty()
        $this.hideList();
        return;
      }
      if (typeof $this.data('swiftype-config-autocomplete').engineKey !== 'undefined') {
        getResults($this, term);
      }
    };

  var processData = function ($this, data, term) {
      var $list = $this.data('swiftype-list'),
        config = $this.data('swiftype-config-autocomplete');

      $list.empty();
      $this.hideList(true);

      config.resultRenderFunction($this.getContext(), data);

      var totalItems = $this.listResults().length;
      if ((totalItems > 0 && $this.focused()) || (config.noResultsMessage !== undefined)) {
        if ($this.submitted) {
          $this.submitted = false;
        } else {
          $this.showList();
        }
      }
    };

  var defaultResultRenderFunction = function(ctx, results) {
    var $list = ctx.list,
      config = ctx.config;

    $.each(results, function(document_type, items) {
      $.each(items, function(idx, item) {
        ctx.registerResult($('<li>' + config.renderFunction(document_type, item) + '</li>').appendTo($list), item);
      });
    });
  };

  var defaultRenderFunction = function(document_type, item) {
    return '<p class="title">' + Swiftype.htmlEscape(item['title']) + '</p>';
  };

  var defaultOnComplete = function(item, prefix) {
    window.location = item['url'];
  };

  var defaultDropdownStylesFunction = function($this) {
    var config = $this.data('swiftype-config-autocomplete');
    var $attachEl = config.attachTo ? $(config.attachTo) : $this;
    var offset = $attachEl.offset();
    var styles = {
      'position': 'absolute',
      'z-index': 9999,
      'top': offset.top + $attachEl.outerHeight() + 1,
      'left': offset.left
    };
    if (config.setWidth) {
      styles['width'] = $attachEl.outerWidth() - 2;
    }
    return styles;
  };

  var handleFunctionParam = function(field) {
    if (field !== undefined) {
      var evald = field;
      if (typeof evald === 'function') {
        evald = evald.call();
      }
      return evald;
    }
    return undefined;
  };

	// simple client-side LRU Cache, based on https://github.com/rsms/js-lru

	function LRUCache(limit) {
	  this.size = 0;
	  this.limit = limit;
	  this._keymap = {};
	}

  LRUCache.prototype.put = function (key, value) {
    var entry = {
      key: key,
      value: value
    };
    this._keymap[key] = entry;
    if (this.tail) {
      this.tail.newer = entry;
      entry.older = this.tail;
    } else {
      this.head = entry;
    }
    this.tail = entry;
    if (this.size === this.limit) {
      return this.shift();
    } else {
      this.size++;
    }
  };

  LRUCache.prototype.shift = function () {
    var entry = this.head;
    if (entry) {
      if (this.head.newer) {
        this.head = this.head.newer;
        this.head.older = undefined;
      } else {
        this.head = undefined;
      }
      entry.newer = entry.older = undefined;
      delete this._keymap[entry.key];
    }
    return entry;
  };

  LRUCache.prototype.get = function (key, returnEntry) {
    var entry = this._keymap[key];
    if (entry === undefined) return;
    if (entry === this.tail) {
      return entry.value;
    }
    if (entry.newer) {
      if (entry === this.head) this.head = entry.newer;
      entry.newer.older = entry.older;
    }
    if (entry.older) entry.older.newer = entry.newer;
    entry.newer = undefined;
    entry.older = this.tail;
    if (this.tail) this.tail.newer = entry;
    this.tail = entry;
    return returnEntry ? entry : entry.value;
  };

  LRUCache.prototype.remove = function (key) {
    var entry = this._keymap[key];
    if (!entry) return;
    delete this._keymap[entry.key];
    if (entry.newer && entry.older) {
      entry.older.newer = entry.newer;
      entry.newer.older = entry.older;
    } else if (entry.newer) {
      entry.newer.older = undefined;
      this.head = entry.newer;
    } else if (entry.older) {
      entry.older.newer = undefined;
      this.tail = entry.older;
    } else {
      this.head = this.tail = undefined;
    }

    this.size--;
    return entry.value;
  };

  LRUCache.prototype.clear = function () {
    this.head = this.tail = undefined;
    this.size = 0;
    this._keymap = {};
  };

  if (typeof Object.keys === 'function') {
    LRUCache.prototype.keys = function () {
      return Object.keys(this._keymap);
    };
  } else {
    LRUCache.prototype.keys = function () {
      var keys = [];
      for (var k in this._keymap) keys.push(k);
      return keys;
    };
  }

  $.fn.swiftype.defaults = {
    activeItemClass: 'active',
    attachTo: undefined,
    documentTypes: undefined,
    filters: undefined,
    engineKey: undefined,
    searchFields: undefined,
    functionalBoosts: undefined,
    sortField: undefined,
    sortDirection: undefined,
    fetchFields: undefined,
    highlightFields: undefined,
    noResultsClass: 'noResults',
    noResultsMessage: undefined,
    onComplete: defaultOnComplete,
    resultRenderFunction: defaultResultRenderFunction,
    renderFunction: defaultRenderFunction,
    dropdownStylesFunction: defaultDropdownStylesFunction,
    resultLimit: undefined,
    suggestionListType: 'ul',
    suggestionListClass: 'autocomplete',
    resultListSelector: 'li',
    setWidth: true,
    typingDelay: 80,
    disableAutocomplete: false,
    autocompleteContainingElement: 'body',
    widgetContainerClass: 'swiftype-widget'
  };

})(jQuery);

(function ($) {
  var queryParser = function (a) {
      var i, p, b = {};
      if (a === "") {
        return {};
      }
      for (i = 0; i < a.length; i += 1) {
        p = a[i].split('=');
        if (p.length === 2) {
          b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
        }
      }
      return b;
    };
  $.queryParams = function () {
    return queryParser(window.location.search.substr(1).split('&'));
  };
  $.hashParams = function () {
    return queryParser(window.location.hash.substr(1).split('&'));
  };


  window.Swiftype = window.Swiftype || {};
  Swiftype.root_url = Swiftype.root_url || 'https://api.swiftype.com';
  Swiftype.pingUrl = function(endpoint, callback) {
    var to = setTimeout(callback, 350);
    var img = new Image();
    img.onload = img.onerror = function() {
      clearTimeout(to);
      callback();
    };
    img.src = endpoint;
    return false;
  };
  Swiftype.pingSearchResultClick = function (engineKey, docId, callback) {
    var params = {
      t: new Date().getTime(),
      engine_key: engineKey,
      doc_id: docId,
      q: Swiftype.currentQuery
    };
    var url = Swiftype.root_url + '/api/v1/public/analytics/pc?' + $.param(params);
    Swiftype.pingUrl(url, callback);
  };

  $.fn.swiftypeSearch = function (options) {
    var options = $.extend({}, $.fn.swiftypeSearch.defaults, options);

    return this.each(function () {
      var $this = $(this);
      var config = $.meta ? $.extend({}, options, $this.data()) : options;
      $this.data('swiftype-config-search', config);

      $this.selectedCallback = function (data) {
        return function (e) {
          var $el = $(this);
          e.preventDefault();
          Swiftype.pingSearchResultClick(config.engineKey, data['id'], function() {
            config.onComplete($el);
          });
        };
      };

      $this.registerResult = function ($element, data) {
        $element.data('swiftype-item', data);
        $('a', $element).click($this.selectedCallback(data));
      };

      $this.getContentCache = function () {
        return $('#' + contentCacheId);
      };

      var $resultContainer = $(config.resultContainingElement),
        initialContentOfResultContainer = $resultContainer.html(),
        contentCacheId = 'st-content-cache',
        $contentCache = $this.getContentCache();

      var setSearchHash = function (query, page) {
          location.hash = "stq=" + encodeURIComponent(query) + "&stp=" + page;
        };

      var submitSearch = function (query, options) {
          options = $.extend({
            page: 1
          }, options);
          var params = {};

          if (!$contentCache.length) {
            $resultContainer.after("<div id='" + contentCacheId + "' style='display: none;'></div>");
            $contentCache.html(initialContentOfResultContainer).hide();
          }
          config.loadingFunction(query, $resultContainer);

          Swiftype.currentQuery = query;
          params['q'] = query;
          params['engine_key'] = config.engineKey;
          params['page'] = options.page;

          function handleFunctionParam(field) {
            if (field !== undefined) {
              var evald = field;
              if (typeof evald === 'function') {
                evald = evald.call();
              }
              return evald;
            }
            return undefined;
          }

          params['per_page'] = handleFunctionParam(config.perPage);
          params['search_fields'] = handleFunctionParam(config.searchFields);
          params['fetch_fields'] = handleFunctionParam(config.fetchFields);
          params['facets'] = handleFunctionParam(config.facets);
          params['filters'] = handleFunctionParam(config.filters);
          params['document_types'] = handleFunctionParam(config.documentTypes);
          params['functional_boosts'] = handleFunctionParam(config.functionalBoosts);
          params['sort_field'] = handleFunctionParam(config.sortField);
          params['sort_direction'] = handleFunctionParam(config.sortDirection);
          params['spelling'] = handleFunctionParam(config.spelling);
          params['highlight_fields'] = handleFunctionParam(config.highlightFields);

          $.ajax({
            dataType: "json",
            url: Swiftype.root_url + "/api/v1/public/engines/search.json?callback=?",
            data: params,
            xhrFields: { withCredentials: true },
            success: renderSearchResults
          });
        };

      $(window).hashchange(function () {
        var params = $.hashParams();
        if (params.stq) {
          submitSearch(params.stq, {
            page: params.stp
          });
        } else {
          var $contentCache = $this.getContentCache();
          if ($contentCache.length) {
            $resultContainer.html($contentCache.html());
            $contentCache.remove();
          }
        }
      });

      var $containingForm = $this.parents('form');
      if ($containingForm) {
        $containingForm.bind('submit', function (e) {
          e.preventDefault();
          var searchQuery = $this.val();
          setSearchHash(searchQuery, 1);
        });
      }

      $(document).on('click', '[data-hash][data-page]', function (e) {
        e.preventDefault();
        var $this = $(this);
        setSearchHash($.hashParams().stq, $this.data('page'));
      });

      $(document).on('click', '[data-hash][data-spelling-suggestion]', function (e) {
        e.preventDefault();
        var $this = $(this);
        setSearchHash($this.data('spelling-suggestion'), 1);
      });

      var renderSearchResults = function (data) {
        if (typeof config.preRenderFunction === 'function') {
          config.preRenderFunction.call($this, data);
        }

        config.renderResultsFunction($this.getContext(), data);

        if (typeof config.postRenderFunction === 'function') {
          config.postRenderFunction.call($this, data);
        }
      };

      $this.getContext = function () {
        return {
          config: config,
          resultContainer: $resultContainer,
          registerResult: $this.registerResult
        };
      };

      $(window).hashchange(); // if the swiftype query hash is present onload (maybe the user is pressing the back button), submit a query onload
    });
  };

  var renderPagination = function (ctx, resultInfo) {
    var maxPagesType, maxPages = -1,
      config = ctx.config;
    $.each(resultInfo, function(documentType, typeInfo) {
      if (typeInfo.num_pages > maxPages) {
        maxPagesType = documentType;
        maxPages = typeInfo.num_pages;
      }
    });
    var currentPage = resultInfo[maxPagesType].current_page,
      totalPages = resultInfo[maxPagesType].num_pages;

    $(config.renderPaginationForType(maxPagesType, currentPage, totalPages)).appendTo(ctx.resultContainer);
  };


  var normalize = function (str) {
      return $.trim(str).toLowerCase();
    };

  function htmlEscape(str) {
    return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  var defaultRenderResultsFunction = function (ctx, data) {
    var $resultContainer = ctx.resultContainer,
      config = ctx.config;

    $resultContainer.html('');

    $.each(data.records, function (documentType, items) {
      $.each(items, function (idx, item) {
        ctx.registerResult($(config.renderFunction(documentType, item)).appendTo($resultContainer), item);
      });
    });

    renderPagination(ctx, data.info);
  };

  var defaultRenderFunction = function (document_type, item) {
      return '<div class="st-result"><h3 class="title"><a href="' + item['url'] + '" class="st-search-result-link">' + htmlEscape(item['title']) + '</a></h3></div>';
    };

  var defaultLoadingFunction = function(query, $resultContainer) {
      $resultContainer.html('<p class="st-loading-message">loading...</p>');
    };

  var defaultOnComplete = function(elem) {
    window.location = elem.attr('href');
  };

  var defaultPostRenderFunction = function(data) {
    var totalResultCount = 0;
    var $resultContainer = this.getContext().resultContainer;
    var spellingSuggestion = null;

    if (data['info']) {
      $.each(data['info'], function(index, value) {
        totalResultCount += value['total_result_count'];
        if ( value['spelling_suggestion'] ) {
          spellingSuggestion = value['spelling_suggestion']['text'];
        }

      });
    }

    if (totalResultCount === 0) {
      $resultContainer.html("<div id='st-no-results' class='st-no-results'>No results found.</div>");
    }

    if (spellingSuggestion !== null) {
      $resultContainer.append('<div class="st-spelling-suggestion">Did you mean <a href="#" data-hash="true" data-spelling-suggestion="' + spellingSuggestion + '">' + spellingSuggestion + '</a>?</div>');
    }
  };


  var defaultRenderPaginationForType = function (type, currentPage, totalPages) {
      var pages = '<div class="st-page">',
        previousPage, nextPage;
      if (currentPage != 1) {
        previousPage = currentPage - 1;
        pages = pages + '<a href="#" class="st-prev" data-hash="true" data-page="' + previousPage + '">&laquo; previous</a>';
      }
      if (currentPage < totalPages) {
        nextPage = currentPage + 1;
        pages = pages + '<a href="#" class="st-next" data-hash="true" data-page="' + nextPage + '">next &raquo;</a>';
      }
      pages += '</div>';
      return pages;
    };


  $.fn.swiftypeSearch.defaults = {
    attachTo: undefined,
    documentTypes: undefined,
    facets: undefined,
    filters: undefined,
    engineKey: undefined,
    searchFields: undefined,
    functionalBoosts: undefined,
    sortField: undefined,
    sortDirection: undefined,
    fetchFields: undefined,
    highlightFields: undefined,
    preRenderFunction: undefined,
    postRenderFunction: defaultPostRenderFunction,
    loadingFunction: defaultLoadingFunction,
    renderResultsFunction: defaultRenderResultsFunction,
    renderFunction: defaultRenderFunction,
    renderPaginationForType: defaultRenderPaginationForType,
    onComplete: defaultOnComplete,
    perPage: 10,
    spelling: 'strict'
  };
})(jQuery);

$(window).load(function(){
  window.productItemColor = {
    'Red': '#ae001a',
    'Green': '#00b133',
    'Blue': '#0066ce',
    'Regatta Blue': '#0094ce',
    'Navy': '#003448',
    'Black': '#000000',
    'Grey': '#928f98',
    'White': '#ffffff',
    'Yellow': '#f0e000',
    'Orange': '#e96b19',
    'Pink': '#ff3d6b',
    'Purple': '#7e5d98',
    'Beige': '#d1b98d',
    'Turquoise': '#00afb1',
    'Light Blue': '#79d4ff',
    'Light Green': '#78ff71',
    'Forest': '#034100',
    'Burgundy': '#590000',
    'Light Grey': '#c4c4c4',
    'Charcoal': '#393939',
    'Brown': '#723100',
    'Gold': '#efa101',
    'Cardinal': '#96002a',
    'Light Brown': '#b5662c',
    'Dark Brown': '#311500',
    'Light Pink': '#ffff9f',
    'WhiteBlack': '#ffffff',
    'BlackWhite': '#000000',
    'WhiteHthBlack': '#525252',
    'HthrBlackBlack': '#525252',
    'Silver': '#bfc8cc',
    'Lieutenant': '#67695a',
    'Camel': '#864a12',
    'Coral': '#ff5960',
    'Sangria': '#c9004e',
    'Raspberry': '#bf0076',
    'Truffle': '#6d323a',
    'Blush': '#ffcdea',
    'Peach': '#f7d0c1',
    'Mauve': '#dac0c4',
    'Lavender': '#bfb0d6',
    'Eggplant': '#552a5c',
    'Lapis': '#23377c',
    'Royal Blue': '#0662c1',
    'NeoHtrBlue': '#00b0f0',
    'Baby Blue': '#91bee9',
    'WhiteHthLkeBlu': '#449bac',
    'Olive': '#3d4c3a',
    'Kelly Green': '#0a8249',
    'Lime': '#cff2dc',
    'Sea Foam': '#e0ebe3',
    'Ash Grey SF': '#cddbcf',
    'Red Navy': '#ff0000',
    'Green Lapis': '#00b050',
    'Grey Navy': '#222b35',
    'Grey Truffle': '#6d323a',
    'Neon Green': '#a2e96f',
    'Neon Yellow': '#e0fc5d',
    'Neon Pink': '#ffa3bc',
    'Army': '#8e735e',
    'Maroon': '#800000',
    'Cream': '#fffdd0',
    'Light Navy': '#000080',
    'Teal': '#008080',
    'Tan': '#d2b48c',
    'Neon Orange': '#fD5f00',
    'Light Red': '#bf0000',
    'Lemon': '#fff700',
    'Mint': '#98ff98',
  }

  window.searchConfig = {
    facets: {},
    sort: {
      field: undefined,
      direction: undefined
    }
  };

  window.winWidth = parseInt($(window).width(),10);
  window.itemCount = '';
  window.value = '';
  window.oldSearchQuery = null;
  window.oldFacets = null;
  window.newSearchQuery = null;

  // This function returns an array of all url parameters for the current window
  window.getAllUrlParams = function(url) {
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
    var obj = {};
    if (queryString) {
      queryString = queryString.split('#')[0];
      var arr = queryString.split('&');
  
      for (var i = 0; i < arr.length; i++) {
        var a = arr[i].split('=');
        var paramName = a[0];
        var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
        paramName = paramName.toLowerCase();

        if (typeof paramValue === 'string') {
          paramValue = paramValue.toLowerCase();
        }

        if (paramName.match(/\[(\d+)?\]$/)) {
          var key = paramName.replace(/\[(\d+)?\]/, '');

          if (!obj[key]) {
            obj[key] = [];
          } 

          if (paramName.match(/\[\d+\]$/)) {
            var index = /\[(\d+)\]/.exec(paramName)[1];
            obj[key][index] = paramValue;
          } else {
            obj[key].push(paramValue);
          }
        } else {
          if (!obj[paramName]) {
            obj[paramName] = paramValue;
          } else if (obj[paramName] && typeof obj[paramName] === 'string'){
            obj[paramName] = [obj[paramName]];
            obj[paramName].push(paramValue);
          } else {
            obj[paramName].push(paramValue);
          }
        }
      }
    }
    return obj;
  }

  // This function either redirects the user to the correct search url or does nothing, depending on if a user is coming from an AMP page
  window.identifyAmpSubmissions = function() {
    var url = document.URL;
    var params = getAllUrlParams(url);
    if (params.amp === "true") {
      redirectAmpSubmissions();
    } else {
      return false;
    }
  }

  // This function performs the redirect to the search results with a corrected search query syntax if needed. The identifyAmpSubmissions() function makes this distinction.
  window.redirectAmpSubmissions = function() {
    var urlBase = window.location.href.split('?')[0];
    var oldQuery = window.location.search;
    var newQuery = oldQuery.replace("?", "#");
    var fullUrl = urlBase + newQuery;
    window.location.replace(fullUrl); 
  }

  identifyAmpSubmissions();
  
  window.customRenderFunction = function(document_type, item) {
    var date = new Date(item['published_on']);
    var html = "";
    var data = '';
    var itemPrice = parseFloat(item['price']).toFixed(2);
    if( typeof item['title'] != 'undefined' || item['title'] != '' ){
      data += '<div class="col-xs-6 col-sm-6 col-md-4 no-padding product-list "><div class="scaleOnHover product-list-inner"><div class="product-area text-center clearfix"><div class="product-info"><div class="product-thumbnail"><a href="'+item['url']+'"><img src="'+item['image']+'" alt=""></a></div><h4><a href="'+item['url']+'">'+item['title']+'</a></h4><div class="price">MSRP: <span class="product-price"><span class="money">$'+itemPrice+'</span></span></div></div></div></div></div>';
    }
    html = data;
    return html;
  };

  window.$facetContainer = $('.st-dynamic-facets');

  window.reloadResults = function() {
    dbCnvrtCurrent();
    $('#st-results-container2').empty();
    $(window).hashchange(); // This hashchange is required for the search results to refresh
  };

  window.bindControls = function(data) {
    dbCnvrtCurrent();

    var totalResultCount = 0;
    var $resultContainer = this.getContext().resultContainer;
    var spellingSuggestion = null;

    window.urlHash = location.hash.split('&');
    window.urlQuery = window.urlHash[0];
    var
      resultInfo = data['info'],
      str = '',
      facets = '';

    window.isSearchSubmitted = false;

    var totalNumPages = resultInfo['page']['num_pages'];
    var totalResults = resultInfo['page']['total_result_count'];
    window.newSearchQuery = resultInfo['page']['query'];

    if( totalResults <= 15 && totalNumPages < 2){
      location.hash = window.urlQuery + "&stp=" + totalNumPages;
    }

      $.each(resultInfo, function(documentType, typeInfo){

        totalResultCount += typeInfo['total_result_count'];

        if ( typeInfo['spelling_suggestion'] ) {
          spellingSuggestion = typeInfo['spelling_suggestion']['text'];
        }

        if (totalResultCount === 0 ) {
          $resultContainer.html('<div id="st-no-results" class="alert alert-warning mb0 st-no-results text-center col-sm-12"><strong>Sorry No Results Found.</strong></div>');
        }

        if (spellingSuggestion !== null) {
          $resultContainer.append('<div class="st-spelling-suggestion alert alert-info mb0 text-center col-sm-12">Did you mean <a href="#" data-hash="true" data-spelling-suggestion="' + spellingSuggestion + '">' + spellingSuggestion + '</a>?</div>');
        }

        /********************** Render facets based on user queries *********************/
        var tempFacets;
        if( window.oldSearchQuery == window.newSearchQuery && (window.oldFacets != null && window.oldFacets != '') ){
          tempFacets = window.oldFacets;
        }else{
          window.oldFacets = typeInfo.facets;
          tempFacets = typeInfo.facets;
          window.oldSearchQuery = window.newSearchQuery;

        }



        var facetNo = 0;
          $.each(tempFacets, function(field, facetCounts) {
            facetNo++;
            if( field == 'quick_ship'){
              str = 'quick ship';
            }else{
              str = field;
            }
            var filterTitle = str;
            var facetFound = 0;
            var quick_ship_flag = 0;

            var tempfacets = '';

            var filterSecClass = ($('.foption_box_'+facetNo).length > 0 && $('.foption_box_'+facetNo).is(':visible')) ? '' : 'hide-section';
            var arrowSecClass = ($('.foption_box_'+facetNo).length > 0 && $('.foption_box_'+facetNo).is(':visible')) ?  'slider-arrow-active' : '';

            tempfacets += ['<li class="clearfix filter"><a class="filterTitle" href="javascript:void(0)" >', filterTitle, '</a><a href="javascript:void(0);" class="slider-arrow '+arrowSecClass+'">3</a><ul class="coll-filter panel-mm  foption_box_'+facetNo+' '+filterSecClass+'">'].join('');
            $.each(facetCounts, function(label, count) {
              itemCount = count;
              var
                status = "",
                labelStr = "Quick Ship",
                id = encodeURIComponent(label).toLowerCase();
              if (window.searchConfig.facets[field] && window.searchConfig.facets[field].indexOf(label) > -1) {
                status = 'checked="checked"'
              }

              if( label == '1'){
                label = labelStr;
                value = 1;
              }else{
                label = label;
                value = label;
              }

              if(count > 0 && label != quick_ship_flag){
                tempfacets += '<li class="search-radio"><label for="' + id + '"><input type="checkbox"' + status + ' name="' + field + '" value="' + value + '" id="' + id + '">';
                if(field == 'color')
                {
                  if( typeof productItemColor[label] != 'undefined' ){
                    var product_color =  productItemColor[label];
                  }else{
                    var product_color = '';
                  }

                  tempfacets += '<span class="product-filter-label"><span class="product-color" style="background-color:'+ product_color +'"></span>' + label + '</span></label></li>';
                }
                else
                {
                  tempfacets += '<span class="product-filter-label">' + label + '</span></label></li>';
                }

                facetFound++;
              }

            });

            if( itemCount > 0){
              tempfacets += '<a href="#" class="clear-selection" data-name="' + field + '">Clear all</a></ul></li>';
            }

            if(facetFound > 0){
              facets += tempfacets;
            }

          });
          $facetContainer.html(facets);
      });

  };

  window.readSortField = function() {
    return { page: window.searchConfig.sort.field };
  };

  window.readSortDirection = function() {
    return { page: window.searchConfig.sort.direction };
  };

  window.isSearchSubmitted = false;
  window.readFilters = function() {
    
    var temPage =  {};
    
    if(window.isSearchSubmitted){
      window.searchConfig.facets['brand'] = '';
      window.searchConfig.facets['color'] = '';
      window.searchConfig.facets['material'] = '';
      window.searchConfig.facets['style'] = '';
      window.searchConfig.facets['quick_ship'] = '';
      
      temPage['DISCONTINUED'] = 0;
      // Filter out collections and pages from search results page
      temPage['type'] = 'product';
      
      return {
        page: temPage
      }
    }else{
      
      if(typeof window.searchConfig.facets['brand'] != "undefined" && window.searchConfig.facets['brand'] != ""){
          temPage['brand'] = window.searchConfig.facets['brand'];
      }

      if(typeof window.searchConfig.facets['color'] != "undefined" && window.searchConfig.facets['color'] != ""){
          temPage['color'] = window.searchConfig.facets['color'];
      }

      if(typeof window.searchConfig.facets['material'] != "undefined" && window.searchConfig.facets['material'] != ""){
          temPage['material'] = window.searchConfig.facets['material'];
      }

      if(typeof window.searchConfig.facets['style'] != "undefined" && window.searchConfig.facets['style'] != ""){
          temPage['style'] = window.searchConfig.facets['style'];
      }

      if(typeof window.searchConfig.facets['quick_ship'] != "undefined" && window.searchConfig.facets['quick_ship'] != ""){
          temPage['quick_ship'] = window.searchConfig.facets['quick_ship'];
      }
      
      temPage['DISCONTINUED'] = 0;
      // Filter out collections and pages from search results page
      temPage['type'] = 'product';
      
      return {
        page: temPage
      }

    }
  }

  window.customOnComplete = function(elem) {
    dbCnvrtCurrent();
    window.location = elem.attr('href');
  };

  window.customAutocompleteDesign = function(document_type, item) {
    var itemPrice = parseFloat(item['price']).toFixed(2);
    var out ='';
     out += '<div class="autocompleteListWrapper"><div class="autocompleteItemImage"><img src="'+item['image']+'" alt=""></div><div class="autocompleteItemTitle"><p class="title">' + item['title'] + '</p><div class="autocompleteItemPrice"><span class="product-price"><span class="money">$'+itemPrice+'</span></span></div></div></div>';
    return out;
  };

  window.footerCustomAutocompleteDesign = function(document_type, item) {
    var itemPrice = parseFloat(item['price']).toFixed(2);
    var out ='';
     out += '<div id="footer-autocomplete" class="autocompleteListWrapper"><div class="autocompleteItemImage"><img src="'+item['image']+'" alt=""></div><div class="autocompleteItemTitle"><p class="title">' + item['title'] + '</p><div class="autocompleteItemPrice"><span class="product-price"><span class="money">$'+itemPrice+'</span></span></div></div></div>';
    return out;
  };

  window.customResultRenderFunction = function(ctx, results) {
    var $list = ctx.list,
      config = ctx.config;

    $.each(results, function(document_type, items) {
      $.each(items, function(idx, item) {
        var position = 0;
        if( item['type'] == 'product'){
          position = 1;
        }else if( item['type'] == 'collection'){
          position = 2;
        }else{
          position = 3;
        }
        ctx.registerResult($('<li class="autoCompleteResults" data-type="'+item['type']+'" data-position="'+position+'"><a href="'+item['url']+'">' + config.renderFunction(document_type, item) + '</a></li>').appendTo($list), item);
      });
    });
    var $temp = $('<ul></ul>');
    // Reverse the order of autocomplete search results so they match the order on the search results page (also, puts pinned products at the top)
    var listItems = $list.children('li');
    $list.append(listItems.get().reverse());
    $list.find('li').sort(sort_li).appendTo($temp);
    var currentType = '';
    $temp.find('li').each(function(){
      console.log($(this).data('type'));
      if( $(this).data('type') != '' && typeof $(this).data('type') != 'undefined' ){
        if( $(this).data('type') == 'page'){
          var type = 'BRANDS';
        }else{
          var type = ($(this).data('type').toUpperCase())+'S';
        }
        if(currentType != type){
          $('<li class="autoCompleteResults categotyTitle"><div class="autocompleteListWrapper"><div class="autocompleteItemTitle"><p class="title">'+type+'</p></div></div></li>').insertBefore($(this));
          currentType = type;
        }
      }

    });
    $list.html($temp.html());
    if (config.widgetContainerClass && config.widgetContainerClass != "swiftype-widget swiftype-widget-footer") {
      stopBodyScroll();
    }    
    dbCnvrtCurrent();
  };

  /***********Sort results data in categories *********************/
  function sort_li(a, b){
    return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;   
  }
  /******************************************************************/

  /************ Footer Dropdown Design *************************/
  var customDropdownStylesFunction = function($this) {
    var config = $this.data('swiftype-config-autocomplete');
    var $attachEl = config.attachTo ? $(config.attachTo) : $this;
    var offset = $attachEl.parent().parent().offset();
    var styles = {
      'position': 'absolute',
      'z-index': 9999,
      'bottom': (($(document).height()  - offset.top)  - ($attachEl.outerHeight()- 60)),
      'left': offset.left
    };
    if (config.setWidth) {
      styles['width'] = $attachEl.parent().parent().outerWidth();
    }
    return styles;
  };
  /*******************************************************************/


    /********************* Header search init ************************************/
    $('#st-search-input').swiftypeSearch({
      resultContainingElement: '#st-results-container2',
      engineKey: 'PYxrpUNc8zBj3chr1cr9',
      renderFunction: customRenderFunction,
      sortField: readSortField,
      sortDirection: readSortDirection,
      facets: { page: ['brand', 'color', 'material', 'style', 'quick_ship'] },
      filters: readFilters,
      postRenderFunction: bindControls,
      perPage: 15,
      onComplete: customOnComplete, 
      spelling: 'strict',
    });
    /*****************************************************************************/

    /********************* Footer search init ************************************/
    $('#footer-search-textinput').change(function(){
     $('#st-search-input').val($('#footer-search-textinput').val());
    //  $('#st-search-input').parents('form').submit(); // when user change footer search and do not submit it. sync to top search
    });
    $('#st-search-input').change(function(){
     $('#footer-search-textinput').val($('#st-search-input').val());
    });
    /*****************************************************************************/

  /********* Header autocomplete search ***************************/
  $('#st-search-input').swiftype({
    engineKey: 'PYxrpUNc8zBj3chr1cr9',
    renderFunction: customAutocompleteDesign,
    resultLimit: 7,
    resultRenderFunction: customResultRenderFunction,
    noResultsMessage: 'Sorry, no results were found. Please try again!',
    filters: { 
      page: {
        'DISCONTINUED': 0,
      }
    },
    autocompleteContainingElement: '.header',
    dropdownStylesFunction: dropdownStylesFunction
  });

  function dropdownStylesFunction($this) {
    var config = $this.data('swiftype-config-autocomplete');
    var $attachEl = config.attachTo ? $(config.attachTo) : $this;
    var offset = $attachEl.offset();
    var styles = {
      'position': 'absolute',
      'z-index': 9999,
      'left': offset.left
    };
    if (config.setWidth) {
      styles['width'] = $attachEl.outerWidth() - 2;
    }
    if (window.innerWidth <= 768) {
      styles['width'] = '100%';
    }
    return styles;
  
  };
  /**********************************************************/

  /********* Footer autocomplete search ***************************/
  $('#footer-search-textinput').swiftype({
    engineKey: 'PYxrpUNc8zBj3chr1cr9',
    renderFunction: footerCustomAutocompleteDesign,
    resultLimit: 7,
    resultRenderFunction: customResultRenderFunction,
    noResultsMessage: 'Sorry, no results were found. Please try again!',
    suggestionListClass: 'footerResults',
    dropdownStylesFunction: customDropdownStylesFunction,
    widgetContainerClass: 'swiftype-widget swiftype-widget-footer',
    filters: { 
      page: {
        'DISCONTINUED': 0,
      }
    },
  });

  $('#footer-search-textinput').swiftypeSearch({
    resultContainingElement: '#st-results-container2',
    engineKey: 'PYxrpUNc8zBj3chr1cr9',
    renderFunction: customRenderFunction,
    sortField: readSortField,
    sortDirection: readSortDirection,
    facets: { page: ['brand', 'color', 'material', 'style', 'quick_ship'] },
    filters: readFilters,
    postRenderFunction: bindControls,
    perPage: 15,
    onComplete: customOnComplete, 
    spelling: 'strict',
  });
  /**********************************************************/

  $('.sort').on('click', function(e){
    e.preventDefault();
    $('.sort').removeClass('active');
    $(this).addClass('active');
    window.searchConfig.sort.field = $(this).data('field');
    window.searchConfig.sort.direction = $(this).data('direction');
    reloadResults();
  });

  $facetContainer.on('click', '.search-radio', function(e) {
    window.searchConfig.facets = {}; // Set the hash to empty
    $('.st-dynamic-facets input[type="checkbox"]').each(function(idx, obj) {
      var
        $checkbox = $(obj),
        facet = $checkbox.prop('name');
      if(!window.searchConfig.facets[facet]) {
        window.searchConfig.facets[facet] = [];
      }
      if($checkbox.prop('checked')) {
        window.searchConfig.facets[facet].push($checkbox.prop('value'));
      }
      location.hash = window.urlQuery + "&stp=1";
    });
    reloadResults();
  });

  $facetContainer.on('click', 'a.clear-selection', function(e) {
    e.preventDefault();
    location.hash = window.urlQuery + "&stp=1";
    var name = $(this).data('name');
    $('input[name=' + name + ']').prop('checked', false);
    window.searchConfig.facets[name] = [];
    reloadResults();
  });

  /**** Sidebar dropdown animations *****/
  $('body').on("click", ".st-dynamic-facets .filter", function(e){
      if($(e.target).closest('label').length < 1){
        e.preventDefault();
        $(this).find('ul').slideToggle();
        $(this).find('a.slider-arrow').toggleClass('slider-arrow-active');
      }
  });

  $("body").on("click", "#sort-by-list li", function(){
    $("#sort-by-list").slideUp();
  });

  if( winWidth < 768){
    /* Product sort Mobile */
    $('body').on('click', '#sort-by-list li', function (e) {
      // console.log('sort' + e.target);
      $('body').removeClass('active-short');
      $('html').removeClass('scrollHide');

    });

     /* Product filter mobile */
    $('body').on('click', '.st-dynamic-facets .filter .coll-filter label', function (e) {
      // console.log('filter' + e.target);
      $('body').removeClass('active-filter');
      $('html').removeClass('scrollHide');
    });
  }

  var stopBodyScroll = function(){
    var headerHeight = parseInt($('.header').height(),10);
    var winHeight = parseInt($(window).height(),10);
    if(winWidth < 768){
      var listHeight = parseInt(winHeight - headerHeight, 10);
      if( $('.autoCompleteResults').is(':visible') == true || $('.new-search-input').val() != ''){
        $('.swiftype-widget .autocomplete').css('max-height', listHeight);
        $('.swiftype-widget .autocomplete').css('overflow-y','auto');
      }else{
        $('.swiftype-widget .autocomplete').css('max-height', 'auto');
        $('.swiftype-widget .autocomplete').css('overflow-y','hidden');
      }
    }
  }
  $(window).on('resize', function(){
    stopBodyScroll();
  });

  /************** Header and Footer search form submit actions *************************/

  $('#search-form').submit(function(e){
    e.preventDefault();
    window.isSearchSubmitted = true;
    $("#footer-search-textinput").val('');
    $(".search-form-footer").removeClass('form-open');
    $(".nav .cart-item").addClass('cart-item-hide');

    if(typeof window.searchConfig != "undefined"){
      window.searchConfig.sort.field = undefined;
      window.searchConfig.sort.direction = undefined;
    }
    if($('.coll-filter input[type="checkbox"]').length){
      $('.coll-filter input[type="checkbox"]').removeAttr('checked');
    }
    if($('.st-dynamic-facets ul.coll-filter.panel-mm').length){
      $('.st-dynamic-facets ul.coll-filter.panel-mm').hide();
      $('.st-dynamic-facets a.slider-arrow').removeClass('slider-arrow-active');
    }
    $('.sort').removeClass('active');
    var query = $("#st-search-input").val();
    //console.log(query);
    if( query == ''){
      setTimeout(function() { $('#st-results-container2').html('<div id="st-no-results" class="alert alert-warning mb0 st-no-results text-center col-sm-12"><strong>Sorry No Results Found</strong></div>') }, 700);
    }else{
      if(document.getElementById("search-results")){
        //do nothing, Swiftype will handle the event
      }else{
        window.location = "/pages/search-results#stq=" + query;
      }
    }
  });

  $('#footer-search-form').submit(function(e){
    e.preventDefault();
    window.isSearchSubmitted = true;
    $("#st-search-input").val('');
    $(".search-form").removeClass('form-open');
    $(".iconSearch").removeClass('icon_close');
    $(".iconSearch").addClass('icon_search');
    $(".nav .cart-item").removeClass('cart-item-hide');


    if(typeof window.searchConfig != "undefined"){
      window.searchConfig.sort.field = undefined;
      window.searchConfig.sort.direction = undefined;
    }
    if($('.coll-filter input[type="checkbox"]').length){
      $('.coll-filter input[type="checkbox"]').removeAttr('checked');
    }
    if($('.st-dynamic-facets ul.coll-filter.panel-mm').length){
      $('.st-dynamic-facets ul.coll-filter.panel-mm').hide();
      $('.st-dynamic-facets a.slider-arrow').removeClass('slider-arrow-active');
    }
    $('.sort').removeClass('active');
    var query = $("#footer-search-textinput").val();
    if( query == ''){
      setTimeout(function() { $('#st-results-container2').html('<div id="st-no-results" class="alert alert-warning mb0 st-no-results text-center col-sm-12"><strong>Sorry No Results Found</strong></div>') }, 700);
    }else{
      if(document.getElementById("search-results")){
        //do nothing, Swiftype will handle the event
      }else{
        window.location = "/pages/search-results#stq=" + query;
      }
    }
  });

  /**
   * modifications for search page and rendering Brands(pages) and Collections
   */
  let isRenderBnC = getFiltersBnC();
  if (isRenderBnC) {
    $('#st-search-input').swiftypeSearch({
      resultContainingElement: '#st-search-collections',
      engineKey: 'PYxrpUNc8zBj3chr1cr9',
      renderFunction: renderItemBnC,
      filters: filterBnC('collections'),
      perPage: 3,
    });

    $('#st-search-input').swiftypeSearch({
      resultContainingElement: '#st-search-pages',
      engineKey: 'PYxrpUNc8zBj3chr1cr9',
      renderFunction: renderItemBnC,
      filters: filterBnC('pages'),
      perPage: 3,
    });
  }

  function filterBnC(type) {
    if (!document.querySelector('.searchBnCWrapper')) {
      return false;
    }
    document.querySelector('.searchBnCWrapper').style.display = 'none';
    let isRenderBnC = getFiltersBnC(),
      filterSettingsForCollection = {
        page: {
          'type': 'collection',
        }
      },
      filterSettingsForPage = {
        page: {
          'type': 'page',
        }
      };

    if (isRenderBnC) {
      
      if (type == 'collections') {
        return filterSettingsForCollection;
      } else if (type == 'pages') {
        return filterSettingsForPage;
      }
    } else {
      document.querySelector('.searchBnCWrapper').style.display = 'none';

      return false;
    }
    
  }
  
  function renderItemBnC(document_type, item) {
    if (item['type'] != 'product' && getFiltersBnC()) {
      document.querySelector('.searchBnCWrapper').style.display = 'block';

      let selector = '.'+item['type']+'sTitle',
        element = document.querySelector(selector);
      if (element.style.display == 'none') {
        element.style.display = 'list-item';
      }
      let data = '';
      if (typeof item['title'] != 'undefined' || item['title'] != '') {
        data = '<li class="autoCompleteResults" data-type="' + item['type'] + '" data-position="3"><a href="' + item['url'] + '"><div class="autocompleteListWrapper"><div class="autocompleteItemImage"><img src="' + item['image'] + '" alt="' + item['title'] + '"></div><div class="autocompleteItemTitle"><p class="title">' + item['title'] + '</p></div></div></a></li>';
      }
      return data;
    }
  };

  function getFiltersBnC() {
    let filterNamesArray = ['brand', 'color', 'material', 'style', 'quick_ship'],
      isFilters = false;
    filterNamesArray.forEach(function(filterName) {
      if (window.searchConfig.facets[filterName] && window.searchConfig.facets[filterName].length) {
        isFilters = true;
      }
    });
    if (isFilters) {
      return false;
    } else {
      return true;
    }    
  }

});

var eu_countries = ['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'GR', 'ES', 'FR', 'HR', 'IT', 'CY', 'LV', 'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'UK'];

	
function checkAndShowCookieDisclaimer(country_code){
	if(typeof window.cookieconsent != "undefined"){
		if(typeof isWindowLoadedWithCookie != 'undefined' && isWindowLoadedWithCookie == true && $.inArray(country_code, eu_countries) != -1){
			window.cookieconsent.initialise(cookieConsObj);
		}else if($.inArray(country_code, eu_countries) != -1){
			window.addEventListener("load", function(){
				window.cookieconsent.initialise(cookieConsObj);
			});
		} 
	}else if($.inArray(country_code, eu_countries) != -1){
		window.addEventListener("load", function(){
			window.cookieconsent.initialise(cookieConsObj);
		});
	} 
}

(function($, document, window, undefined) {
  window.IPRedirect = {
    init: function(settings) {
      // Assignment
      var self = this;

      self.settings = settings;
      self.redirect = localStorage.getItem("location-redirect");
      self.messageWrap = $("#location-redirect-message,#location-redirect-popup");
      self.currentCountry = $('.current-country', self.messageWrap);
      self.RedirectMe = $('.redirect-me', self.messageWrap);
      self.closeBtn = $('.close-redirect-btn', self.messageWrap);
      self.newStore = $('.new-store', self.messageWrap);

      self.catchAllCountries = settings["redirect_catch_all_countries"];
      self.catchAllURL = settings["redirect_catch_all_url"];
      self.catchAllName = settings["redirect_catch_all_name"];

      self.forceRedirect = settings["redirect_force"] ? true : false;
      self.relativeRedirect = settings["redirect_relative"] ? true : false;
      self.countryTranslations = {
        "Sweden": "Sverige"
      };
      self.domain = "https://reallyfreegeoip.org/json/?callback=?";
      self.redirects = [];
      self.urlMap = {};
      self.featherlight = $.featherlight;

      self.location = {};

      // Preparation
      self.loadRedirects(settings);
      self.mapURLs(self.redirects, "::");
      self.redirect = (typeof self.redirect == "string") ? JSON.parse(self.redirect) : {shown: false, date: null};
      self.redirect.shown = self.getIsRedirectShown();

      // Initialization successful
      return true;
    },
    run: function() {
      var self = this;

      var successCallback = ( self.forceRedirect ) ? self.fetchAndRedirectOnResponse : self.fetchAndShowRedirect,
        activateRedirect = ( ! self.redirect.shown || self.forceRedirect ) ? true : false;

      if( activateRedirect ) {
        self.makeServerCall( self.fetchLocationInfoAndRunCallback, successCallback );

        if( ! self.forceRedirect )
          self.bindRedirect();
      }
    },
    loadRedirects: function(settings) {
      var self = this;
      for(var i = 1; i < 11; ++i) {
        var name = "redirect_" + i;

        self.redirects.push( settings[name] );
      }
    },
    mapURLs: function(stringList, splitter) {
      var self = this;

      for(var i = 0; i < stringList.length; ++i) {
        if( stringList[i] && stringList[i] != "") {
          var splitString = stringList[i].split(splitter);

          if(splitString[2].indexOf("https://") === -1 && splitString[1].indexOf("https://") === -1 ) {
            splitString[2] = "https://" + splitString[2];
          }

          self.urlMap[splitString[0]] = {
            "name": splitString[1],
            "url": splitString[2]
          };
        }
      }

      if(self.catchAllCountries.length > 0) {
        var countries = self.catchAllCountries.split(/[\s,]+/);

        for(var i = 0; i < countries.length; ++i) {
          self.urlMap[ countries[i] ] = {
            "name": self.catchAllName,
            "url": self.catchAllURL
          }
        }
      }

      return self.urlMap;
    },
    getIsRedirectShown: function() {
      var self = this,
        today = new Date(),
        prevDate = new Date(self.redirect.date),
        dayLength = 1000 * 24 * 60 * 60, // in milliseconds
        diffDate = today - prevDate;

      // display query again if localStorage is older than 30 days
      if( diffDate / dayLength > 30 )
        return false;

      return true;
    },
    makeServerCall: function( serverCall, callback ) {
      return serverCall(callback);
    },
    fetchLocationInfoAndRunCallback: function( successCallback ) {
      var self = IPRedirect;

      $.ajax( {
        url: self.domain,
        type: 'POST',
        dataType: 'jsonp',
        async: false,
        success: successCallback,
        error: successCallback
      });
    },
    fetchAndShowRedirect: function( location ) {
      var self = IPRedirect;

      self.location = location;

      var hideHeaderFlg = false;
      if(getParameterByName("us_only") != '' && getParameterByName("us_only") == "true"){
          hideHeaderFlg = true; 
          document.cookie = "hideHeaderFlg=true; path=/";
      }else{
        var hideHeaderCookie = getCookie('hideHeaderFlg');

        if(typeof hideHeaderCookie != "undefined" && hideHeaderCookie == "true"){
            hideHeaderFlg = true; 
        }

      }
	  
	  var dynamicCurrencyCookieName = "currency1525994576"; //live
	  var dynamicCurrencyCookieEncode = "_g1525994576"; //live
	  if(window.location.host == "test-corporatedirectapparel.myshopify.com"){
		  dynamicCurrencyCookieName = "currency1524462844"; //test server
		  dynamicCurrencyCookieEncode = "_g1524462844"; //test server
	  }
	  
	  if(typeof location != 'undefined' && location.country_code != 'undefined'){
		  checkAndShowCookieDisclaimer(location.country_code);
	  }
	  
      if (typeof location != "undefined" &&  typeof location != "undefined" &&  typeof self.urlMap[location.country_code] != "undefined" && self.urlMap[location.country_code].url != null && site_country != location.country_code && hideHeaderFlg == false) {

          document.cookie = dynamicCurrencyCookieName+"=; expires=Thu, 18 Dec 1971 12:00:00 UTC; domain="+window.location.hostname+"; path=/";
          document.cookie = dynamicCurrencyCookieEncode+"=; expires=Thu, 18 Dec 1971 12:00:00 UTC; domain="+window.location.hostname+"; path=/";
          document.cookie = "merch_currency=; expires=Thu, 18 Dec 1970 12:00:00 UTC; path=/";

          

          var countryName = (self.countryTranslations[location.country_name]) ? self.countryTranslations[location.country_name] : location.country_name;

          self.currentCountry.text(countryName);

          var redirectLinksHtml = '';

          var nlink = 0;
          if ( self.urlMap[site_country].url != null &&  typeof self.urlMap[location.country_code] != "undefined" ) {
            //self.urlMap[site_country].url
            redirectLinksHtml += '<a href="javascript:IPRedirect.saveRedirect()" title="'+self.urlMap[site_country].name+'" class="flg-icon '+site_country+'-flag"> &nbsp; </a>';
            nlink++;

          }

          if ( self.urlMap[location.country_code].url != null &&  typeof self.urlMap[location.country_code] != "undefined") {
            if( nlink > 0){
              redirectLinksHtml += '<span class="or-seperator"> Or </span>';
            }
            redirectLinksHtml += '<a href="'+self.urlMap[location.country_code].url+'" title="'+self.urlMap[location.country_code].name+'" class="flg-icon '+location.country_code+'-flag"> &nbsp; </a>';
          }

          if(redirectLinksHtml != ''){
             $('.redirect-other-site-link').html(redirectLinksHtml);
             $('.location-redirect-message').show(); 
          }
          //$('.location-redirect-message')
      }else if(typeof location != "undefined" && location.country_code != null){
        //location-currency-message
        
        if(getCookie('merch_currency') != null && getCookie('merch_currency') != ""){
          document.cookie = dynamicCurrencyCookieName+"="+getCookie('merch_currency')+"; domain="+window.location.hostname+"; path=/";
          document.cookie = dynamicCurrencyCookieEncode+"="+btoa(getCookie('merch_currency'))+"; domain="+window.location.hostname+"; path=/";
        }

       

        if(site_country != location.country_code && (getCookie('merch_currency') == null || getCookie('merch_currency') == "") ){  
            checkAndShowCurrencyHeader();
        }  

      } 
      /*if ( self.urlMap[location.country_code].url != null ) {
        var countryName = (self.countryTranslations[location.country_name]) ? self.countryTranslations[location.country_name] : location.country_name;

        self.currentCountry.text(countryName);
        self.newStore.text( self.urlMap[location.country_code].name );
        if (self.relativeRedirect) {
          self.RedirectMe.attr("href", self.urlMap[location.country_code].url + window.top.location.pathname);
        } else {
          self.RedirectMe.attr("href", self.urlMap[location.country_code].url);
        }
        if (self.settings.redirect_popup) {
                    self.featherlight(
            $('#location-redirect-popup'), {
              afterClose: function(event){
                self.saveRedirect();
              }
            });
        } else {
          self.messageWrap.show();
        }
      }*/

    },
    fetchAndRedirectOnResponse: function( location ) {
      var self = IPRedirect;

      self.location = location;

      if(self.urlMap[location.country_code].url != null) {
        if (self.relativeRedirect) {
          window.top.location.assign(self.urlMap[location.country_code].url + window.top.location.pathname);
        } else {
          window.top.location.assign(self.urlMap[location.country_code].url);
        }
      }
    },
    bindRedirect: function() {
      var self = this;

      // only save to local storage if the user doesn't want to be redirected.
      self.closeBtn.off().on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        self.messageWrap.hide();
        self.featherlight.close();
        self.saveRedirect();
      });

      self.RedirectMe.on("click", function(e) {
        e.stopPropagation();
      });
    },
    saveRedirect: function(key, val) {
      var redirect = {
        shown: true,
        date: Date()
      };
      localStorage.setItem("location-redirect", (JSON.stringify(redirect)));

      if($('.location-redirect-message').length){
        $('.location-redirect-message').hide(); 
      }
    }
  };
})(jQuery, document, window);



/**
 * Featherlight - ultra slim jQuery lightbox
 * Version 1.3.4 - http://noelboss.github.io/featherlight/
 *
 * Copyright 2015, Noël Raoul Bossart (http://www.noelboss.com)
 * MIT Licensed.
**/
(function($) {
  "use strict";

  if('undefined' === typeof $) {
    if('console' in window){ window.console.info('Too much lightness, Featherlight needs jQuery.'); }
    return;
  }

  /* Featherlight is exported as $.featherlight.
     It is a function used to open a featherlight lightbox.

     [tech]
     Featherlight uses prototype inheritance.
     Each opened lightbox will have a corresponding object.
     That object may have some attributes that override the
     prototype's.
     Extensions created with Featherlight.extend will have their
     own prototype that inherits from Featherlight's prototype,
     thus attributes can be overriden either at the object level,
     or at the extension level.
     To create callbacks that chain themselves instead of overriding,
     use chainCallbacks.
     For those familiar with CoffeeScript, this correspond to
     Featherlight being a class and the Gallery being a class
     extending Featherlight.
     The chainCallbacks is used since we don't have access to
     CoffeeScript's `super`.
  */

  function Featherlight($content, config) {
    if(this instanceof Featherlight) {  /* called with new */
      this.id = Featherlight.id++;
      this.setup($content, config);
      this.chainCallbacks(Featherlight._callbackChain);
    } else {
      var fl = new Featherlight($content, config);
      fl.open();
      return fl;
    }
  }

  var opened = [],
    pruneOpened = function(remove) {
      opened = $.grep(opened, function(fl) {
        return fl !== remove && fl.$instance.closest('body').length > 0;
      } );
      return opened;
    };

  // structure({iframeMinHeight: 44, foo: 0}, 'iframe')
  //   #=> {min-height: 44}
  var structure = function(obj, prefix) {
    var result = {},
      regex = new RegExp('^' + prefix + '([A-Z])(.*)');
    for (var key in obj) {
      var match = key.match(regex);
      if (match) {
        var dasherized = (match[1] + match[2].replace(/([A-Z])/g, '-$1')).toLowerCase();
        result[dasherized] = obj[key];
      }
    }
    return result;
  };

  /* document wide key handler */
  var eventMap = { keyup: 'onKeyUp', resize: 'onResize' };

  var globalEventHandler = function(event) {
    $.each(Featherlight.opened().reverse(), function() {
      if (!event.isDefaultPrevented()) {
        if (false === this[eventMap[event.type]](event)) {
          event.preventDefault(); event.stopPropagation(); return false;
        }
      }
    });
  };

  var toggleGlobalEvents = function(set) {
      if(set !== Featherlight._globalHandlerInstalled) {
        Featherlight._globalHandlerInstalled = set;
        var events = $.map(eventMap, function(_, name) { return name+'.'+Featherlight.prototype.namespace; } ).join(' ');
        $(window)[set ? 'on' : 'off'](events, globalEventHandler);
      }
    };

  Featherlight.prototype = {
    constructor: Featherlight,
    /*** defaults ***/
    /* extend featherlight with defaults and methods */
    namespace:    'featherlight',         /* Name of the events and css class prefix */
    targetAttr:   'data-featherlight',    /* Attribute of the triggered element that contains the selector to the lightbox content */
    variant:      null,                   /* Class that will be added to change look of the lightbox */
    resetCss:     false,                  /* Reset all css */
    background:   null,                   /* Custom DOM for the background, wrapper and the closebutton */
    openTrigger:  'click',                /* Event that triggers the lightbox */
    closeTrigger: 'click',                /* Event that triggers the closing of the lightbox */
    filter:       null,                   /* Selector to filter events. Think $(...).on('click', filter, eventHandler) */
    root:         'body',                 /* Where to append featherlights */
    openSpeed:    250,                    /* Duration of opening animation */
    closeSpeed:   250,                    /* Duration of closing animation */
    closeOnClick: 'background',           /* Close lightbox on click ('background', 'anywhere' or false) */
    closeOnEsc:   true,                   /* Close lightbox when pressing esc */
    closeIcon:    '&#10005;',             /* Close icon */
    loading:      '',                     /* Content to show while initial content is loading */
    persist:      false,                  /* If set, the content persist and will be shown again when opened again. 'shared' is a special value when binding multiple elements for them to share the same content */
    otherClose:   null,                   /* Selector for alternate close buttons (e.g. "a.close") */
    beforeOpen:   $.noop,                 /* Called before open. can return false to prevent opening of lightbox. Gets event as parameter, this contains all data */
    beforeContent: $.noop,                /* Called when content is loaded. Gets event as parameter, this contains all data */
    beforeClose:  $.noop,                 /* Called before close. can return false to prevent opening of lightbox. Gets event as parameter, this contains all data */
    afterOpen:    $.noop,                 /* Called after open. Gets event as parameter, this contains all data */
    afterContent: $.noop,                 /* Called after content is ready and has been set. Gets event as parameter, this contains all data */
    afterClose:   $.noop,                 /* Called after close. Gets event as parameter, this contains all data */
    onKeyUp:      $.noop,                 /* Called on key down for the frontmost featherlight */
    onResize:     $.noop,                 /* Called after new content and when a window is resized */
    type:         null,                   /* Specify type of lightbox. If unset, it will check for the targetAttrs value. */
    contentFilters: ['jquery', 'image', 'html', 'ajax', 'iframe', 'text'], /* List of content filters to use to determine the content */

    /*** methods ***/
    /* setup iterates over a single instance of featherlight and prepares the background and binds the events */
    setup: function(target, config){
      /* all arguments are optional */
      if (typeof target === 'object' && target instanceof $ === false && !config) {
        config = target;
        target = undefined;
      }

      var self = $.extend(this, config, {target: target}),
        css = !self.resetCss ? self.namespace : self.namespace+'-reset', /* by adding -reset to the classname, we reset all the default css */
        $background = $(self.background || [
          '<div class="'+css+'-loading '+css+'">',
            '<div class="'+css+'-content">',
              '<span class="'+css+'-close-icon '+ self.namespace + '-close">',
                self.closeIcon,
              '</span>',
              '<div class="'+self.namespace+'-inner">' + self.loading + '</div>',
            '</div>',
          '</div>'].join('')),
        closeButtonSelector = '.'+self.namespace+'-close' + (self.otherClose ? ',' + self.otherClose : '');

      self.$instance = $background.clone().addClass(self.variant); /* clone DOM for the background, wrapper and the close button */

      /* close when click on background/anywhere/null or closebox */
      self.$instance.on(self.closeTrigger+'.'+self.namespace, function(event) {
        var $target = $(event.target);
        if( ('background' === self.closeOnClick  && $target.is('.'+self.namespace))
          || 'anywhere' === self.closeOnClick
          || $target.closest(closeButtonSelector).length ){
          event.preventDefault();
          self.close();
        }
      });

      return this;
    },

    /* this method prepares the content and converts it into a jQuery object or a promise */
    getContent: function(){
      if(this.persist !== false && this.$content) {
        return this.$content;
      }
      var self = this,
        filters = this.constructor.contentFilters,
        readTargetAttr = function(name){ return self.$currentTarget && self.$currentTarget.attr(name); },
        targetValue = readTargetAttr(self.targetAttr),
        data = self.target || targetValue || '';

      /* Find which filter applies */
      var filter = filters[self.type]; /* check explicit type like {type: 'image'} */

      /* check explicit type like data-featherlight="image" */
      if(!filter && data in filters) {
        filter = filters[data];
        data = self.target && targetValue;
      }
      data = data || readTargetAttr('href') || '';

      /* check explicity type & content like {image: 'photo.jpg'} */
      if(!filter) {
        for(var filterName in filters) {
          if(self[filterName]) {
            filter = filters[filterName];
            data = self[filterName];
          }
        }
      }

      /* otherwise it's implicit, run checks */
      if(!filter) {
        var target = data;
        data = null;
        $.each(self.contentFilters, function() {
          filter = filters[this];
          if(filter.test)  {
            data = filter.test(target);
          }
          if(!data && filter.regex && target.match && target.match(filter.regex)) {
            data = target;
          }
          return !data;
        });
        if(!data) {
          if('console' in window){ window.console.error('Featherlight: no content filter found ' + (target ? ' for "' + target + '"' : ' (no target specified)')); }
          return false;
        }
      }
      /* Process it */
      return filter.process.call(self, data);
    },

    /* sets the content of $instance to $content */
    setContent: function($content){
      var self = this;
      /* we need a special class for the iframe */
      if($content.is('iframe') || $('iframe', $content).length > 0){
        self.$instance.addClass(self.namespace+'-iframe');
      }

      self.$instance.removeClass(self.namespace+'-loading');

      /* replace content by appending to existing one before it is removed
         this insures that featherlight-inner remain at the same relative
         position to any other items added to featherlight-content */
      self.$instance.find('.'+self.namespace+'-inner')
        .not($content)                /* excluded new content, important if persisted */
        .slice(1).remove().end()      /* In the unexpected event where there are many inner elements, remove all but the first one */
        .replaceWith($.contains(self.$instance[0], $content[0]) ? '' : $content);

      self.$content = $content.addClass(self.namespace+'-inner');

      return self;
    },

    /* opens the lightbox. "this" contains $instance with the lightbox, and with the config.
      Returns a promise that is resolved after is successfully opened. */
    open: function(event){
      var self = this;
      self.$instance.hide().appendTo(self.root);
      if((!event || !event.isDefaultPrevented())
        && self.beforeOpen(event) !== false) {

        if(event){
          event.preventDefault();
        }
        var $content = self.getContent();

        if($content) {
          opened.push(self);

          toggleGlobalEvents(true);

          self.$instance.fadeIn(self.openSpeed);
          self.beforeContent(event);

          /* Set content and show */
          return $.when($content)
            .always(function($content){
              self.setContent($content);
              self.afterContent(event);
            })
            .then(self.$instance.promise())
            /* Call afterOpen after fadeIn is done */
            .done(function(){ self.afterOpen(event); });
        }
      }
      self.$instance.detach();
      return $.Deferred().reject().promise();
    },

    /* closes the lightbox. "this" contains $instance with the lightbox, and with the config
      returns a promise, resolved after the lightbox is successfully closed. */
    close: function(event){
      var self = this,
        deferred = $.Deferred();

      if(self.beforeClose(event) === false) {
        deferred.reject();
      } else {

        if (0 === pruneOpened(self).length) {
          toggleGlobalEvents(false);
        }

        self.$instance.fadeOut(self.closeSpeed,function(){
          self.$instance.detach();
          self.afterClose(event);
          deferred.resolve();
        });
      }
      return deferred.promise();
    },

    /* Utility function to chain callbacks
       [Warning: guru-level]
       Used be extensions that want to let users specify callbacks but
       also need themselves to use the callbacks.
       The argument 'chain' has callback names as keys and function(super, event)
       as values. That function is meant to call `super` at some point.
    */
    chainCallbacks: function(chain) {
      for (var name in chain) {
        this[name] = $.proxy(chain[name], this, $.proxy(this[name], this));
      }
    }
  };

  $.extend(Featherlight, {
    id: 0,                                    /* Used to id single featherlight instances */
    autoBind:       '[data-featherlight]',    /* Will automatically bind elements matching this selector. Clear or set before onReady */
    defaults:       Featherlight.prototype,   /* You can access and override all defaults using $.featherlight.defaults, which is just a synonym for $.featherlight.prototype */
    /* Contains the logic to determine content */
    contentFilters: {
      jquery: {
        regex: /^[#.]\w/,         /* Anything that starts with a class name or identifiers */
        test: function(elem)    { return elem instanceof $ && elem; },
        process: function(elem) { return this.persist !== false ? $(elem) : $(elem).clone(true); }
      },
      image: {
        regex: /\.(png|jpg|jpeg|gif|tiff|bmp|svg)(\?\S*)?$/i,
        process: function(url)  {
          var self = this,
            deferred = $.Deferred(),
            img = new Image(),
            $img = $('<img src="'+url+'" alt="" class="'+self.namespace+'-image" />');
          img.onload  = function() {
            /* Store naturalWidth & height for IE8 */
            $img.naturalWidth = img.width; $img.naturalHeight = img.height;
            deferred.resolve( $img );
          };
          img.onerror = function() { deferred.reject($img); };
          img.src = url;
          return deferred.promise();
        }
      },
      html: {
        regex: /^\s*<[\w!][^<]*>/, /* Anything that starts with some kind of valid tag */
        process: function(html) { return $(html); }
      },
      ajax: {
        regex: /./,            /* At this point, any content is assumed to be an URL */
        process: function(url)  {
          var self = this,
            deferred = $.Deferred();
          /* we are using load so one can specify a target with: url.html #targetelement */
          var $container = $('<div></div>').load(url, function(response, status){
            if ( status !== "error" ) {
              deferred.resolve($container.contents());
            }
            deferred.fail();
          });
          return deferred.promise();
        }
      },
      iframe: {
        process: function(url) {
          var deferred = new $.Deferred();
          var $content = $('<iframe/>')
            .hide()
            .attr('src', url)
            .css(structure(this, 'iframe'))
            .on('load', function() { deferred.resolve($content.show()); })
            // We can't move an <iframe> and avoid reloading it,
            // so let's put it in place ourselves right now:
            .appendTo(this.$instance.find('.' + this.namespace + '-content'));
          return deferred.promise();
        }
      },
      text: {
        process: function(text) { return $('<div>', {text: text}); }
      }
    },

    functionAttributes: ['beforeOpen', 'afterOpen', 'beforeContent', 'afterContent', 'beforeClose', 'afterClose'],

    /*** class methods ***/
    /* read element's attributes starting with data-featherlight- */
    readElementConfig: function(element, namespace) {
      var Klass = this,
        regexp = new RegExp('^data-' + namespace + '-(.*)'),
        config = {};
      if (element && element.attributes) {
        $.each(element.attributes, function(){
          var match = this.name.match(regexp);
          if (match) {
            var val = this.value,
              name = $.camelCase(match[1]);
            if ($.inArray(name, Klass.functionAttributes) >= 0) {  /* jshint -W054 */
              val = new Function(val);                           /* jshint +W054 */
            } else {
              try { val = $.parseJSON(val); }
              catch(e) {}
            }
            config[name] = val;
          }
        });
      }
      return config;
    },

    /* Used to create a Featherlight extension
       [Warning: guru-level]
       Creates the extension's prototype that in turn
       inherits Featherlight's prototype.
       Could be used to extend an extension too...
       This is pretty high level wizardy, it comes pretty much straight
       from CoffeeScript and won't teach you anything about Featherlight
       as it's not really specific to this library.
       My suggestion: move along and keep your sanity.
    */
    extend: function(child, defaults) {
      /* Setup class hierarchy, adapted from CoffeeScript */
      var Ctor = function(){ this.constructor = child; };
      Ctor.prototype = this.prototype;
      child.prototype = new Ctor();
      child.__super__ = this.prototype;
      /* Copy class methods & attributes */
      $.extend(child, this, defaults);
      child.defaults = child.prototype;
      return child;
    },

    attach: function($source, $content, config) {
      var Klass = this;
      if (typeof $content === 'object' && $content instanceof $ === false && !config) {
        config = $content;
        $content = undefined;
      }
      /* make a copy */
      config = $.extend({}, config);

      /* Only for openTrigger and namespace... */
      var namespace = config.namespace || Klass.defaults.namespace,
        tempConfig = $.extend({}, Klass.defaults, Klass.readElementConfig($source[0], namespace), config),
        sharedPersist;

      $source.on(tempConfig.openTrigger+'.'+tempConfig.namespace, tempConfig.filter, function(event) {
        /* ... since we might as well compute the config on the actual target */
        var elemConfig = $.extend(
          {$source: $source, $currentTarget: $(this)},
          Klass.readElementConfig($source[0], tempConfig.namespace),
          Klass.readElementConfig(this, tempConfig.namespace),
          config);
        var fl = sharedPersist || $(this).data('featherlight-persisted') || new Klass($content, elemConfig);
        if(fl.persist === 'shared') {
          sharedPersist = fl;
        } else if(fl.persist !== false) {
          $(this).data('featherlight-persisted', fl);
        }
        elemConfig.$currentTarget.blur(); // Otherwise 'enter' key might trigger the dialog again
        fl.open(event);
      });
      return $source;
    },

    current: function() {
      var all = this.opened();
      return all[all.length - 1] || null;
    },

    opened: function() {
      var klass = this;
      pruneOpened();
      return $.grep(opened, function(fl) { return fl instanceof klass; } );
    },

    close: function() {
      var cur = this.current();
      if(cur) { return cur.close(); }
    },

    /* Does the auto binding on startup.
       Meant only to be used by Featherlight and its extensions
    */
    _onReady: function() {
      var Klass = this;
      if(Klass.autoBind){
        /* Bind existing elements */
        $(Klass.autoBind).each(function(){
          Klass.attach($(this));
        });
        /* If a click propagates to the document level, then we have an item that was added later on */
        $(document).on('click', Klass.autoBind, function(evt) {
          if (evt.isDefaultPrevented()) {
            return;
          }
          evt.preventDefault();
          /* Bind featherlight */
          Klass.attach($(evt.currentTarget));
          /* Click again; this time our binding will catch it */
          $(evt.target).click();
        });
      }
    },

    /* Featherlight uses the onKeyUp callback to intercept the escape key.
       Private to Featherlight.
    */
    _callbackChain: {
      onKeyUp: function(_super, event){
        if(27 === event.keyCode) {
          if (this.closeOnEsc) {
            this.$instance.find('.'+this.namespace+'-close:first').click();
          }
          return false;
        } else {
          return _super(event);
        }
      },

      onResize: function(_super, event){
        if (this.$content.naturalWidth) {
          var w = this.$content.naturalWidth, h = this.$content.naturalHeight;
          /* Reset apparent image size first so container grows */
          this.$content.css('width', '').css('height', '');
          /* Calculate the worst ratio so that dimensions fit */
          var ratio = Math.max(
            w  / parseInt(this.$content.parent().css('width'),10),
            h / parseInt(this.$content.parent().css('height'),10));
          /* Resize content */
          if (ratio > 1) {
            this.$content.css('width', '' + w / ratio + 'px').css('height', '' + h / ratio + 'px');
          }
        }
        return _super(event);
      },

      afterContent: function(_super, event){
        var r = _super(event);
        this.onResize(event);
        return r;
      }
    }
  });

  $.featherlight = Featherlight;

  /* bind jQuery elements to trigger featherlight */
  $.fn.featherlight = function($content, config) {
    return Featherlight.attach(this, $content, config);
  };

  /* bind featherlight on ready if config autoBind is set */
  $(document).ready(function(){ Featherlight._onReady(); });
}(jQuery));

var countryCodeCurrency = {"BD": "BDT", "BE": "EUR", "BF": "XOF", "BG": "BGN", "BA": "BAM", "BB": "BBD", "WF": "XPF", "BL": "EUR", "BM": "BMD", "BN": "BND", "BO": "BOB", "BH": "BHD", "BI": "BIF", "BJ": "XOF", "BT": "BTN", "JM": "JMD", "BV": "NOK", "BW": "BWP", "WS": "WST", "BQ": "USD", "BR": "BRL", "BS": "BSD", "JE": "GBP", "BY": "BYR", "BZ": "BZD", "RU": "RUB", "RW": "RWF", "RS": "RSD", "TL": "USD", "RE": "EUR", "TM": "TMT", "TJ": "TJS", "RO": "RON", "TK": "NZD", "GW": "XOF", "GU": "USD", "GT": "GTQ", "GS": "GBP", "GR": "EUR", "GQ": "XAF", "GP": "EUR", "JP": "JPY", "GY": "GYD", "GG": "GBP", "GF": "EUR", "GE": "GEL", "GD": "XCD", "GB": "GBP", "GA": "XAF", "SV": "USD", "GN": "GNF", "GM": "GMD", "GL": "DKK", "GI": "GIP", "GH": "GHS", "OM": "OMR", "TN": "TND", "JO": "JOD", "HR": "HRK", "HT": "HTG", "HU": "HUF", "HK": "HKD", "HN": "HNL", "HM": "AUD", "VE": "VEF", "PR": "USD", "PS": "ILS", "PW": "USD", "PT": "EUR", "SJ": "NOK", "PY": "PYG", "IQ": "IQD", "PA": "PAB", "PF": "XPF", "PG": "PGK", "PE": "PEN", "PK": "PKR", "PH": "PHP", "PN": "NZD", "PL": "PLN", "PM": "EUR", "ZM": "ZMK", "EH": "MAD", "EE": "EUR", "EG": "EGP", "ZA": "ZAR", "EC": "USD", "IT": "EUR", "VN": "VND", "SB": "SBD", "ET": "ETB", "SO": "SOS", "ZW": "ZWL", "SA": "SAR", "ES": "EUR", "ER": "ERN", "ME": "EUR", "MD": "MDL", "MG": "MGA", "MF": "EUR", "MA": "MAD", "MC": "EUR", "UZ": "UZS", "MM": "MMK", "ML": "XOF", "MO": "MOP", "MN": "MNT", "MH": "USD", "MK": "MKD", "MU": "MUR", "MT": "EUR", "MW": "MWK", "MV": "MVR", "MQ": "EUR", "MP": "USD", "MS": "XCD", "MR": "MRO", "IM": "GBP", "UG": "UGX", "TZ": "TZS", "MY": "MYR", "MX": "MXN", "IL": "ILS", "FR": "EUR", "IO": "USD", "SH": "SHP", "FI": "EUR", "FJ": "FJD", "FK": "FKP", "FM": "USD", "FO": "DKK", "NI": "NIO", "NL": "EUR", "NO": "NOK", "NA": "NAD", "VU": "VUV", "NC": "XPF", "NE": "XOF", "NF": "AUD", "NG": "NGN", "NZ": "NZD", "NP": "NPR", "NR": "AUD", "NU": "NZD", "CK": "NZD", "XK": "EUR", "CI": "XOF", "CH": "CHF", "CO": "COP", "CN": "CNY", "CM": "XAF", "CL": "CLP", "CC": "AUD", "CA": "CAD", "CG": "XAF", "CF": "XAF", "CD": "CDF", "CZ": "CZK", "CY": "EUR", "CX": "AUD", "CR": "CRC", "CW": "ANG", "CV": "CVE", "CU": "CUP", "SZ": "SZL", "SY": "SYP", "SX": "ANG", "KG": "KGS", "KE": "KES", "SS": "SSP", "SR": "SRD", "KI": "AUD", "KH": "KHR", "KN": "XCD", "KM": "KMF", "ST": "STD", "SK": "EUR", "KR": "KRW", "SI": "EUR", "KP": "KPW", "KW": "KWD", "SN": "XOF", "SM": "EUR", "SL": "SLL", "SC": "SCR", "KZ": "KZT", "KY": "KYD", "SG": "SGD", "SE": "SEK", "SD": "SDG", "DO": "DOP", "DM": "XCD", "DJ": "DJF", "DK": "DKK", "VG": "USD", "DE": "EUR", "YE": "YER", "DZ": "DZD", "US": "USD", "UY": "UYU", "YT": "EUR", "UM": "USD", "LB": "LBP", "LC": "XCD", "LA": "LAK", "TV": "AUD", "TW": "TWD", "TT": "TTD", "TR": "TRY", "LK": "LKR", "LI": "CHF", "LV": "EUR", "TO": "TOP", "LT": "LTL", "LU": "EUR", "LR": "LRD", "LS": "LSL", "TH": "THB", "TF": "EUR", "TG": "XOF", "TD": "XAF", "TC": "USD", "LY": "LYD", "VA": "EUR", "VC": "XCD", "AE": "AED", "AD": "EUR", "AG": "XCD", "AF": "AFN", "AI": "XCD", "VI": "USD", "IS": "ISK", "IR": "IRR", "AM": "AMD", "AL": "ALL", "AO": "AOA", "AQ": "", "AS": "USD", "AR": "ARS", "AU": "AUD", "AT": "EUR", "AW": "AWG", "IN": "INR", "AX": "EUR", "AZ": "AZN", "IE": "EUR", "ID": "IDR", "UA": "UAH", "QA": "QAR", "MZ": "MZN"}; // taken from http://country.io/currency.json


var isCurrencySwitcherAvailable = false;

function afterCurrencySwitcherInit(){
  isCurrencySwitcherAvailable = true;
  customizeDoubly();
}

function checkAndShowCurrencyHeader(){  
    if(isCurrencySwitcherAvailable == true){
      $('.location-currency-message').show();
    }else{
      setTimeout(function(){ checkAndShowCurrencyHeader();  }, 1000);
    }
   
}
 
function customizeDoubly() {
  	setTimeout(function(){
  		if(typeof jQueryGrizzly != 'undefined' && typeof IPRedirect.location != 'undefined' && IPRedirect.location.country_code != site_country){ 
  			if($('[name=doubly-currencies]').closest('.location-currency-message').length) { 
	  			jQueryGrizzly('[name=doubly-currencies]').unbind('change');

	  			$('.btn-currency-go').on('click',function(){
	  				    var newCurrency = jQueryGrizzly('[name=doubly-currencies] option:selected').val();
                if(typeof newCurrency == 'undefined' ||  newCurrency == null){
                  newCurrency = DoublyGlobalCurrency.cookie.read();
                }
	  				    setCookie("merch_currency",newCurrency,365);
                DoublyGlobalCurrency.convertAll(newCurrency); /* in case more than 1 currency switcher, update value of all of them */
                jQueryGrizzly('[name=doubly-currencies]').val(jQueryGrizzly(this).val());

                if(!$(this).hasClass('trigger-from-nav')){ 
                  $('.location-currency-message').hide();
                  cloneDoublyToNavHeader(); 
                }else{ 
                  $('.btn-currency-go').removeClass('trigger-from-nav');
                }
	  			});

          if(getCookie('merch_currency') != null && getCookie('merch_currency') != ""){ 

            cloneDoublyToNavHeader();
            $("body").addClass('body-nav-currency'); 

          }else{

            if(typeof IPRedirect.location != "undefined" && typeof IPRedirect.location.country_code != "undefined" && $('.doubly-nice-select ul li[data-value="'+countryCodeCurrency[IPRedirect.location.country_code]+'"]').length){
              $('.doubly-nice-select ul li').removeClass('selected');
              var currencyDrop = $('.doubly-nice-select ul li[data-value="'+countryCodeCurrency[IPRedirect.location.country_code]+'"]');

              currencyDrop.addClass('selected');
              $('.doubly-nice-select span.current').html('<span class="flags flags-'+currencyDrop.attr('data-country')+'"></span> &nbsp;'+currencyDrop.attr('data-display'));
              
               jQueryGrizzly('[name=doubly-currencies]').val(currencyDrop.attr('data-value'));
            }
            

            
          }

	  		}
	  	}
	 },1000); 
}

function cloneDoublyToNavHeader(){
  $("body").addClass('body-nav-currency');
  $(".currency-nav-container").html('');
  $("[name=doubly-currencies]").next('.doubly-nice-select').clone().appendTo(".currency-nav-container");
  $("[name=doubly-currencies]").next('.doubly-nice-select').clone().appendTo(".currency-nav-content-container");
  $(".currency-nav-container").show();
  $(".currency-nav-content-container").show();

  bindSelectCurrencyEvent(); 

  if($('.doubly-message-cart-row').length){ 
    $('.doubly-message-cart-row').show();  
  }

  //hide survey form 
 if(DoublyGlobalCurrency.currentCurrency != 'USD'){
   $('.product-survey.sec-area').hide(); 
   $('.doubly-message-cart-row').show(); 
 }else{
    $('.product-survey.sec-area').show(); 
    $('.doubly-message-cart-row').hide(); 
 }


}

function bindSelectCurrencyEvent(){

  if($('select[name=doubly-currencies]').length){ 
    $('select[name=doubly-currencies]').change(function(){
      setTimeout(function(){ 
          replaceCurrencyText(); 
      }, 100);  
    }) 
  }

}

function replaceCurrencyText(){
  
  if($('.doubly-message-cart-row').length){ 
    $('.doubly-message-cart-row .selected-currency').html(DoublyGlobalCurrency.currentCurrency); 
  } 

   //hide survey form
   if(DoublyGlobalCurrency.currentCurrency != 'USD'){
     $('.product-survey.sec-area').hide(); 
     $('.doubly-message-cart-row').show(); 
     $('.doubly-message-cart-row .doubly-message.free-offer-msg').show();
   }else{
      $('.product-survey.sec-area').show(); 
      $('.doubly-message-cart-row').hide(); 
   }
   
   if(typeof changePrice == "function"){
      changePrice("");
   }

 /* $('.current-currency').each(function(){
      $(this).html(DoublyGlobalCurrency.currentCurrency);
  })*/

}

function dbCnvrtCurrent(){
  if(typeof jQueryGrizzly != 'undefined' && typeof DoublyGlobalCurrency != "undefined" && typeof DoublyGlobalCurrency.cookie != "undefined" ){ 
    var newCurrency = jQueryGrizzly('[name=doubly-currencies] option:selected').val();
    if(typeof newCurrency == 'undefined' ||  newCurrency == null){
      newCurrency = DoublyGlobalCurrency.cookie.read();
    } 
    DoublyGlobalCurrency.convertAll(newCurrency);  
  }
}
$('body').on('click','.currency-nav-container .doubly-nice-select ul.list li, .currency-nav-content-container .doubly-nice-select ul.list li',function(){
    $('.btn-currency-go').addClass('trigger-from-nav');
    setTimeout(function(){ $('.btn-currency-go').trigger('click'); }, 100);
})

$('h2,p,h3,.tabPanelDetails,li,.item-price').each(function(){
  var tagTempHtml = $(this).html();
  if($(this).find('.money').length < 1 && tagTempHtml.search(/(\$[0-9\-\.\,]+)/g) != -1  && $(this).closest('.hbspt-form').length < 1 ){ 
    var fTempHtml = tagTempHtml.replace(/(\$[0-9\-\.\,]+)/g,"<span class='money'>$1</span>") ; 
    $(this).html(fTempHtml);
  }
})

$(window).load(function(){ 

  setTimeout(function(){
    $('h2,h3,p,.tabPanelDetails,li,.item-price,.wisepop-content span').each(function(){
      var tagTempHtml = $(this).html();
      if($(this).find('.money').length < 1  && tagTempHtml.search(/(\$[0-9\-\.\,]+)/g) != -1  && $(this).closest('.hbspt-form').length < 1 ){ 
        var fTempHtml = tagTempHtml.replace(/(\$[0-9\-\.\,]+)/g,"<span class='money'>$1</span>") ; 
        $(this).html(fTempHtml);
      }
    }) 

    setTimeout(function(){
      dbCnvrtCurrent();
    },100);

  },1000);

})

// This function can be used to manually convert a currency value using Doubly
function convertAmountDirectly(cents,currentMoneyTxt){

  if(typeof DoublyGlobalCurrency != 'undefined'){ 
    var shopCurrency = 'USD';
    
    if (typeof cents == "string") {
      // Convert cents to a number, because keeping it as a string can cause miscalculations
      cents = parseFloat(cents);
    }

    if (shopCurrency != DoublyGlobalCurrency.currentCurrency) {
        cents = DoublyGlobalCurrency.convert(cents, shopCurrency, DoublyGlobalCurrency.currentCurrency);
    }  

     var newFormat = DoublyGlobalCurrency.moneyFormats[DoublyGlobalCurrency.currentCurrency][DoublyGlobalCurrency.format] || "{{amount}}";
     var isShopCurrency = (DoublyGlobalCurrency.currentCurrency == "USD") ? true : false;

     return DoublyGlobalCurrency.formatMoney(cents, newFormat, isShopCurrency, false);
   }else{
     return currentMoneyTxt;
   }

}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires+ ";path=/";
}
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length,c.length);
      }
  }
  return "";
}
function eraseCookie(name) {   
  document.cookie = name+'=; Max-Age=-99999999;';  
}

window['friendbuy'] = window['friendbuy'] || [];
window['friendbuy'].push(['site', 'site-5c846fb3-host']);
window['friendbuy'].push(['track', 'customer',
{
  id: '{{ customer.id }}',
  email: '{{ customer.email }}',
  first_name: '{{ customer.first_name }}',
  last_name: '{{ customer.last_name }}'
}
]);
(function (f, r, n, d, b, y) {
b = f.createElement(r), y = f.getElementsByTagName(r)[0];b.async = 1;b.src = n;y.parentNode.insertBefore(b, y);
})(document, 'script', '//djnf6e5yyirys.cloudfront.net/js/friendbuy.min.js');

/*<!-- Pinterest base code -->*/
!function(e){if(!window.pintrk){window.pintrk=function()
{window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
n=window.pintrk;n.queue=[],n.version="3.0";var
t=document.createElement("script");t.async=!0,t.src=e;var
r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)}}
("https://s.pinimg.com/ct/core.js");

pintrk('load','2615791285943', { em: '{{ customer.email }}', });
pintrk('page');

(function() {var s = document.createElement('script');s.type = 'text/javascript';s.async = true;
s.src = document.location.protocol + '//loader.wisepops.com/default/index/get-loader?user_id=20062';
var s2 = document.getElementsByTagName('script')[0];s2.parentNode.insertBefore(s, s2);})();

var isWindowLoadedWithCookie = false;
var cookieConsObj = {
  "palette": {
    "popup": {
      "background": "#4B4B55"
    },
    "button": {
      "background": "#ffffff",
      "text": "#f26522"
    }
  },
  "theme": "classic",
  "content": {
  header: 'Cookies used on the website!',
  message: 'We use cookies to give you the best experience on our website. By continuing to browse the site, you are agreeing to our use of cookies. More information can be found in our <a href="{{ shop.url }}/pages/privacy-policy">Privacy Policy</a> and <a href="{{ shop.url }}/pages/terms-of-service">Terms of Service</a>.',
  dismiss: '',
  showLink: 'false',
  }
};
window.addEventListener("load", function(){
  isWindowLoadedWithCookie = true;
});
var winHeight = "";
var winWidth = "";
var $jquery = (typeof $jquery != 'undefined') ? $jquery : $;
var originalLeave = null;
var headerHeight = "";
var isSampleOrder = false;

$(document).ready(function() {
  // Call these functions when the document is ready
  initSlick();
  openModalFromUrlParameter();
  bodyTopPadding();
  shortHeight();
  tabHeights();
  setAllEqualHeights();

  if (!$( "#content-mobile" ).length) {
    $('.page-control h3 .arrow').hide();
  }
  
  $('.search_area, li.search-close').click(function () {
    $('.search-form').toggleClass('form-open');
    $(this).children('.iconSearch').toggleClass('icon_search');
    $(this).children('.iconSearch').toggleClass('icon_close');
    $('li.cart-item').toggleClass('cart-item-hide');     
    if (!$(this).children('.iconSearch')[0].classList.contains('icon_search')) {
      $('#st-search-input').focus(); 
    }
  });
  
  $('body').on('touchend click', '.footer-box-menu-section .search_btn', function (event) {
    event.preventDefault();
    //console.log("Search opened");
    $('.search-form-footer').toggleClass('form-open');
    if ($('.search-form-footer')[0].classList.contains('form-open')) {
      $('#footer-search-textinput').focus(); 
    }
  });
  
  $('.close_search').click(function () {
    $('.search-form-footer').removeClass('form-open');
  });
  /* Product sort */
  $('.product-shorting-trigger').click(function () {
      $('#sort-by-list').slideToggle();
      $('.sort-by').toggleClass('active');
      $('body').toggleClass('product-shorting-active');
  });
  $(document).mouseup(function(e){
    //close popup if clicked outside of the box
    var sortContainer = $(".sort-by");
    if (!sortContainer.is(e.target) && sortContainer.has(e.target).length === 0 && sortContainer.hasClass('active')){
        $('.product-shorting-trigger').click();
    }
  });
  /* Product sort mobile */
  $('.short-trigger, .closeShort').click(function () {
      $('body').toggleClass('active-short');
      $('html').toggleClass('scrollHide');
  });
   /* Product filter mobile */
  $('.filter-trigger, .closeFilter').click(function () {
      $('body').toggleClass('active-filter');
      $('html').toggleClass('scrollHide');
  });
  /* Mobile product sizing tab */
  $('.productSizeLink, .closeProductSizeLink').click(function () {
      $('body').toggleClass('activeProductSizeLink');
      $('html').toggleClass('scrollHide');
  });
  /* Mobile product details tab */
  $('.productDetailLink, .closeProductDetails').click(function () {
      $('body').toggleClass('activeProductDetail');
      $('html').toggleClass('scrollHide');
  });
  /* Mobile custom reviews tab */
  $('.productReviewLink, .closeProductReviewLink').click(function () {
      $('body').toggleClass('activeProductReviewLink');
      $('html').toggleClass('scrollHide');
  });
  /* Mobile Shipping & Delivery */
  $('.productShippingLink, .closeProductShippingLink').click(function () {
      $('body').toggleClass('activeProductShippingLink');
      $('html').toggleClass('scrollHide');
  });
  
  $('.navbar .dropdown > a').click(function(){
      location.href = this.href;
  });
  
  $(".dropdown").hover(
      function () {
          $('.dropdown-menu', this).fadeIn("fast");
      },
      function () {
          $('.dropdown-menu', this).fadeOut("fast");
  });

  $(".dropdown").on('touchend', function(event) {
    $('.dropdown-menu').fadeOut("fast");
    $('.dropdown-toggle').removeClass("active");
    if ($('.dropdown-menu', this)[0].style.display == 'block') {
      $('.dropdown-menu', this).fadeOut("fast");
    } else {
      event.preventDefault();
      $('.dropdown-menu', this).fadeIn("fast");
      $('.dropdown-toggle', this).first().addClass("active");
    }
  })

  document.querySelector('body').addEventListener('touchend', function(event) {
    if (document.querySelector('.main-nav').contains(event.target)) {
      // debugger
    } else {
      $('.dropdown-menu').fadeOut("fast");
      $('.dropdown-toggle').removeClass("active");
    }
  }, true)

  $('.menu-trigger,.mobile-menu-close').click(function () {
      $('body').toggleClass('slide-active');
  });
  
  // The following code block handles clicks on mobile menu dropdowns
  $('li.menu-item a.hasChildren, li.menu-item a.hasSubChildren').on('click' ,function (e) {
      e.preventDefault();
      var $thisAnchor = $(this);
      $thisAnchor.next().next('.sub-menu').slideToggle(500, function () {
  
          if ( $thisAnchor.closest('li.menu-item').hasClass('active') ) {
              $thisAnchor.closest('li.menu-item').removeClass('active')
          } else {
              $thisAnchor.closest('li.menu-item').addClass('active')
          }
      });
      $thisAnchor.parents('li.menu-item').siblings('li.menu-item.active').children('ul.sub-menu').slideToggle(300, function () {
          $thisAnchor.parents('li.menu-item').siblings('li.menu-item.active').find('ul.sub-menu').hide();
          $thisAnchor.parents('li.menu-item').siblings('li.menu-item.active').removeClass('active');
      });
  });
  // The following code block handles clicks on mobile menu arrows for dropdowns
  $('span.menu-arrow').click(function (e) {
      e.preventDefault();
      var $thisArrow = $(this);
      $thisArrow.next('.sub-menu').slideToggle(500, function () {
          if ( $thisArrow.closest('li.menu-item').hasClass('active') ) {
              $thisArrow.closest('li.menu-item').removeClass('active')
          } else {
              $thisArrow.closest('li.menu-item').addClass('active')
          }
      });
      $thisArrow.parents('li.menu-item').siblings('li.menu-item.active').children('ul.sub-menu').slideToggle(300, function () {
          $thisArrow.parents('li.menu-item').siblings('li.menu-item.active').find('ul.sub-menu').hide();
          $thisArrow.parents('li.menu-item').siblings('li.menu-item.active').removeClass('active');
      });
  });
  
  $( ".form-control" ).focus(function() {
      $(this).closest('.form-group').removeClass('focused').addClass('focused');
  });

  $( ".form-control" ).blur(function() {
      if ( $(this).val().length > 0 ) {
          $(this).closest('.form-group').removeClass('focused').addClass('focused');
      } else {
          $(this).closest('.form-group').removeClass('focused');
      }
  });
  
  /**** Hubspot Form Fields - Add/remove "focus" class for inputs and labels ****/
  $( "body" ).on('focus','.hs-form .hs-input',function() {
      $(this).closest('.hs-form-field').removeClass('focused').addClass('focused');
  });

  $( "body" ).on('blur','.hs-form .hs-input',function() {
      if ( $(this).val().length > 0 ) {
          $(this).closest('.hs-form-field').removeClass('focused').addClass('focused');
      } else {
          $(this).closest('.hs-form-field').removeClass('focused');
      }
  });
  
  /** Activate Account Form */
  $( "body" ).on('focus','.active-account-form input',function() {
      $(this).closest('.active-account-form .field ').removeClass('focused').addClass('focused');
  });

  $( "body" ).on('blur','.active-account-form input',function() {
      if ( $(this).val().length > 0 ) {
          $(this).closest('.active-account-form .field').removeClass('focused').addClass('focused');
      } else {
          $(this).closest('.active-account-form .field').removeClass('focused');
      }
  });
  
  $("input.form-control").bind('focus', function() {
     $(this).css('background-color', 'white');
  });
  
  $('.readMore').click(function() {
      var $this = $(this);
      $this.toggleClass('readMore');
      if ($this.hasClass('readMore')) {
        $this.text('Read More');
      } else {
        $this.text('Read Less');
      }
  });
  
  $(document).on('click', '#close-preview', function() {
      $('.image-preview').popover('hide');
      // Hover befor close the preview
      $('.image-preview').hover(
          function () {
             $('.image-preview').popover('show');
          },
           function () {
             $('.image-preview').popover('hide');
          }
      );
  });
  
  // Clear event
  $('body').on('click','.image-preview-clear', function() {
      var $el = $(this);
      $el.closest('.fu_render').find('.image-show').hide();
      $el.closest('.fu_render').find('.uplodedLogo').hide();
      //$('.image-show #dynamic').remove();
      $el.closest('.fu_render').find('.imageTitle').hide();
      $el.closest('.fu_render').find('.image-preview-filename').val("");
      $el.closest('.fu_render').find('.image-preview-clear').hide();
      $el.closest('.fu_render').find('.image-preview-input input:file').val("");
      $el.closest('.fu_render').find(".image-preview-input-title").text(" Browse");
  });
  
  // Create the preview image
  $('body').on('change','.image-preview-input input:file',function(){
      var img = $('<img/>', { id: 'dynamic' });
      var $el = $(this);
      var file = this.files[0];
      var reader = new FileReader();
      // Set preview image into the popover data-content
      reader.onload = function (e) {
          $el.closest('.fu_render').find('.image-show').show();
          $el.closest('.fu_render').find('.uplodedLogo ').show();
          $el.closest('.fu_render').find(".image-preview-input-title").text(" Change");
          $el.closest('.fu_render').find(".image-preview-clear").show();
          $el.closest('.fu_render').find(".image-preview-filename").val(file.name);
          $el.closest('.fu_render').find(".imageTitle").show().text($(".image-preview-filename").val());
          img.attr('src', e.target.result);
          $el.closest('.fu_render').find('.image-show').show();
          $el.closest('.fu_render').find('.image-show').html($(img)[0].outerHTML);
      }
      reader.readAsDataURL(file);
  });
  
  $('.mobileProductTitle').html($('.productTitle').html());
  $('.mobileProductPrice').html($('.productPriceValue').html());
  
  /* FAQs accordion */
  $(".msg_head").click(function (){
      $(this).next(".msg_body").slideToggle();
      $(this).parents(".faqList").toggleClass("active");
      $(this).parents(".faqList").siblings(".faqList").removeClass("active");
      $(this).parents(".faqList").siblings(".faqList").find(".msg_body").slideUp();
  });

    
  $('body').addClass('secLoading');

  $('.account-box').addClass('scaleOnHover');

  if (typeof($.fn.tooltip) != 'undefined') {
    if ($('html').hasClass('touch')) {
      $('[data-toggle="tooltip"]').tooltip();
    } else {
      // delayToolTip();
      $('[data-toggle="tooltip"]').tooltip({ delay: { show: 50,  hide: 300 }});
    }
  }
    
  $(".numbers-row").append('<span class="inc button buttnQtyChange arrow_triangle-up"></span><span class="dec button buttnQtyChange arrow_triangle-down"></span>');
  
  $("body").on("click",".buttnQtyChange", function () {
      let newVal = 0;
      var $button = $(this);
      var oldValue = $button.parent().find("input").val() * 1;

      if( $(this).closest('.ProductSizeInfo').length > 0 ) {
        $(this).parent().find("input").trigger('input');
        // Product Page
        if (!$(this).parents('.ProductSizeInfo').hasClass('outOfStock')) {
            if ($button.hasClass('inc')) {
                if (isSampleOrder && parseInt(oldValue) > 0) {
                  newVal = oldValue;
                }
                else {
                  newVal = parseInt(oldValue) + 1;
                }
                $(this).parents('.ProductSizeInfo').addClass('selected');
            } else {
                /** Don't allow decrementing below zero **/
                if (oldValue > 1) {
                    newVal = parseInt(oldValue) - 1;
                } else {
                    newVal = 0;
                    $(this).parents('.ProductSizeInfo').removeClass('selected');
                }
            }
        }
        $button.parent().find("input").val(newVal);
      } else {
        // Cart Page
        if ($button.hasClass('inc')) {
            newVal = parseInt(oldValue) + 1;
        } else {
          /** Don't allow decrementing below zero **/
          if (oldValue > 1) {
            newVal = parseInt(oldValue) - 1;
          } else {
            newVal = 0;
          }
        }
        $button.parent().find("input").val(newVal);
      }

  });
  
  if (typeof($.fn.hasExtension) == 'undefined') { 
    $.fn.hasExtension = function(exts) {
        return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$', 'ig')).test($(this).val());
    }
  }
  
  if ( location.pathname != "/" ) {
    if ( $(window).width() <= 767 ) {
      // Mobile menu active class script
      $('.mobile-menu-accordion a').each(function() {
            if ( $(this).attr('href') == location.pathname ) {
              $(this).closest('li').addClass('active');
              $(this).parents('.menu-item').addClass('active');
              $(this).parents('.sub-menu').show();
              $(this).siblings('ul.sub-menu').first().show();
            }
      });

      setTimeout(function() {
          if ( $('.mobile-menu-accordion .active').length == 0 ) {
            $('.breadcrumb-content-area li').each(function() {
              if ( $(this).find('a').attr('href') != "/" && $(this).find('a').attr('href') != "undefined" ) {
                if ( $('.mobile-menu-accordion a[href="'+$(this).find('a').attr('href')+'"]').length > 0 ) {
                  $('.mobile-menu-accordion a[href="'+$(this).find('a').attr('href')+'"]').closest('li').addClass('active');
                  $('.mobile-menu-accordion a[href="'+$(this).find('a').attr('href')+'"]').parents('.sub-menu').show();
                  $('.mobile-menu-accordion a[href="'+$(this).find('a').attr('href')+'"]').siblings('ul.sub-menu').first().show();
                }
              }
            });
          }
      },1000);
    } else {
        // Desktop menu active class script
        $('.main-nav a').each(function() {
            if ( $(this).attr('href') == location.pathname ) {
                // add active class to the parent li of current page
                $(this).closest('li').addClass('active');

                if ( $(this).hasClass('dropdown-toggle') ) {
                    // for main menu ( 1st level )
                } else if ( $(this).closest('ul').find('.dropdown-header').length > 0 ) {
                    // for Grand child  menu ( 3rd level )
                    if ( $(this).closest('ul').find('.dropdown-header').length == 1 ) {
                      $(this).closest('ul').find('.dropdown-header').addClass('active');
                    } else if ( $(this).closest('li').hasClass('dropdown-header') ) {
                      $(this).closest('li').addClass('active');
                    } else {
                      $(this).closest('li').prev('.dropdown-header').addClass('active');
                    }
                    $(this).parents('.dropdown').find('.dropdown-toggle').closest('li').addClass('active');
                } else {
                    // for child  menu ( 2nd level )
                    $(this).parents('.dropdown').find('.dropdown-toggle').closest('li').addClass('active');
                }

            }
        });

        setTimeout(function() {
            if ( $('.main-nav .active').length == 0 ) {
              $('.breadcrumb-content-area li').each(function() {
                  if ( $(this).find('a').attr('href') != "/" && $(this).find('a').attr('href') != "undefined" ) {
                    if ( $('.main-nav a[href="'+$(this).find('a').attr('href')+'"]').length > 0 ) {
                        $('.main-nav a[href="'+$(this).find('a').attr('href')+'"]').closest('li').addClass('active');
                    }
                  }
              });
            }
        },1000);
    }
  }
  
  $(window).trigger('resize');
  
  $('body').on('click','.ProductSizeText .icon_circle-empty,.ProductSizeText .size-lable',function() {
    if ( !$(this).closest('.ProductSizeInfo').hasClass('selected') && !$(this).closest('.ProductSizeInfo').hasClass('outOfStock') ) {
        $(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').trigger('input');
        $(this).closest('.ProductSizeInfo').addClass('selected');
        $(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').val(1);
    } else if( $(this).closest('.ProductSizeInfo').hasClass('selected') && !$(this).closest('.ProductSizeInfo').hasClass('outOfStock') ) {
        $(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').trigger('input');
        $(this).closest('.ProductSizeInfo').removeClass('selected');
        $(this).closest('.ProductSizeInfo').removeClass('quantity-more-than-max');
        $(this).closest('.ProductSizeInfo').find('.numbers-row input[type=text],.numbers-row input[type=number]').val(0);
    }
  });
  
  function checkForMaxQuantity($input) {
    var $thisInputVal = $input.val();
    var $thisInputMax = $input.attr('max');
    if ( !isNaN($thisInputVal) && !isNaN($thisInputMax) ) {
      if( $thisInputVal < $thisInputMax ) {
        $input.closest('.ProductSizeInfo').removeClass('quantity-more-than-max');
      }
    }
  }
  
  $('.applyDiscOnChange').bind('input',function() {
        $('.addToCart').attr('disabled',false);
        var $tempThis = $(this);
        checkForMaxQuantity($tempThis);
        setTimeout(function() {
            if ( typeof changePrice != "undefined" )
            changePrice('change');

            if ( $tempThis.val() != "" && $tempThis.val() != "0" ) {
                if ( !$tempThis.closest('.ProductSizeInfo').hasClass('selected') && !$tempThis.closest('.ProductSizeInfo').hasClass('outOfStock') ) {
                    $tempThis.closest('.ProductSizeInfo').addClass('selected');
                }
            } else {
                $tempThis.closest('.ProductSizeInfo').removeClass('selected');
            }
        },20);

  });
  
  $('.applyDiscOnChange').bind('focus',function() {
      if ( $(this).val() == "0" ) {
        $(this).val('');
      }
  });
  
  $('.applyDiscOnChange').bind('blur',function() {
      if( $(this).val() == "" ) {
        $(this).val('0');
      }
  });
  
  //merchPerks product restriction to 1 quantity only
  $('.merchperk-prod-inp').bind('input',function() {
      setTimeout(function() {
            var tempTotalQty = 0;
            $('.merchperk-prod-inp').each(function() {
              if (!isNaN(parseInt($(this).val()))) {
                tempTotalQty = tempTotalQty + parseInt($(this).val());
              }
            });

            if (tempTotalQty > 1) {
              $('.CartBtnSec .addToCart').attr('disabled','disabled').addClass('merchperk-error');
              $('.CartBtnSec .error').addClass('merchperk-error').html('You can only add one MerchPerk to each order.<br> Please adjust your selected quantity to continue.').show();
            } else {
              if ($('.CartBtnSec .addToCart').hasClass('merchperk-error')) {
                  $('.CartBtnSec .addToCart').removeAttr('disabled').removeClass('merchperk-error');
              }
              if ($('.CartBtnSec .error').hasClass('merchperk-error')) {
                  $('.CartBtnSec .error').html('').hide().removeClass('merchperk-error');
              }
            }
      },30);

  });

  // When user clicks the "Details" link on the DESKTOP product page, scroll to the DETAILS tab and open it
  $('body').on('click', '.show-product-details-tab', function() {
    $('html,body').animate({
      scrollTop: eval($('.productTabs .nav-tabs').offset().top-10)
    }, 1000);
    $('a[aria-controls="details"]').trigger('click');
  });
  
    
  //footer autocomplete position set    
  setTimeout(function(){ setFooterAutoPos(); }, 1000);
  $( ".form-sec-footer .ui-autocomplete-input:first" ).change(function(){
    setFooterAutoPos();
  });
  
  $(window).resize(function() {
    setTimeout(function(){ setFooterAutoPos(); }, 100);
  });
  
  var inputText = $( "input,textarea" );
  inputText.each(function() {
    if($(this).val().length != 0 ) {
      $(this).parents().addClass('focused');
    }
  });
  
  $('body').on('click','.product-adjust-maximum-quantity',function() {
    var totalNumOfVariants = $('#variant-size').val() * 1;
    for (i =0; i <= totalNumOfVariants; i++) {
      var variant_qty = $("#quantity-"+i).val() * 1;
      var variant_qty_max = $("#variant-max-"+i).val() * 1;
      if ( !isNaN(variant_qty) && !isNaN(variant_qty_max) ) {
        if ( variant_qty > variant_qty_max ) {
          $("#quantity-"+i).val(variant_qty_max);
          $("#quantity-"+i).closest('.ProductSizeInfo').removeClass('quantity-more-than-max');
        }
      }
    }
    $('.CartBtnSec p.error').html('').hide();
    $('.CartBtnSec p.success').html('Quantities automatically adjusted! Click the Add to Cart button above to continue with your order.').show();
    changePrice(); // this function is in price-script.liquid
    $('.addToCart').attr('disabled',false); // renable the Add to Cart button
    checkIfMinimumQuantityAchieved();
  });
  
  /* Handle clicks on the Getting Started Survey's next button */
  $('.product-survey-next').click(function() {

    if ($(this).hasClass('disabledSurBtn')) {
      return false;
    }

    $('.product-survey-next').removeClass('next-active-state');

    var $activeHSFieldIndex = $('.product-survey div.hs-form-field').index($('.activeHSField'));
    var $currentHBFormSurvey =  $('.product-survey div.hs-form-field:eq('+$activeHSFieldIndex+')');
    var $hbFormSurveyActive = $('.product-survey div.hs-form-field.activeHSField');

    if ($activeHSFieldIndex > 0 &&  $('.product-survey-inner .hs_brand_custom').length < 1) {
      $activeHSFieldIndex = $activeHSFieldIndex + 1;
    }

    var $parentDependantField = $hbFormSurveyActive.closest('.hs-dependent-field');
    //console.log("Parent Field" + $parentDependantField.length);

    if ($parentDependantField.length) {
      if ( $hbFormSurveyActive.find('select').length ) {
          console.log( $hbFormSurveyActive.find('select').val());
          if ( typeof $hbFormSurveyActive.find('select').val() == "undefined" || typeof $hbFormSurveyActive.find('select').val() == "object" || typeof $hbFormSurveyActive.find('select').val() == null) {
              $hbFormSurveyActive.addClass('product-survey-field-error');
              return false;
          }
      } else if ( $hbFormSurveyActive.find('input').length ) {
          if ( $hbFormSurveyActive.find('input').val() == "" ) {
              $hbFormSurveyActive.addClass('product-survey-field-error');
              return false;
          }
      }
    }

    var formFieldWrapper = $hbFormSurveyActive;
    var nextSurveyField = $('.product-survey div.hs-form-field:not(.hs_form_submission_domain):eq('+($activeHSFieldIndex+1)+')');
    var $hbFormSurvey = $('.product-survey div.hs-form-field');
    
    if ( nextSurveyField.length > 0 ) {
      if ( $hbFormSurveyActive.find('select').length ) {
        if ( typeof $hbFormSurveyActive.find('select').val() != "undefined" && typeof $hbFormSurveyActive.find('select').val() != "object" ) {
          console.log("Select found. Showing Next");
          $hbFormSurveyActive.hide();
          $hbFormSurveyActive.removeClass('product-survey-field-error');
          nextSurveyField.show().addClass('activeHSField');
          $currentHBFormSurvey.removeClass('activeHSField');
          $('.product-survey-inner').addClass('step-'+( $activeHSFieldIndex + 1 ) );
        } else {
          console.log("Select field error");
          $hbFormSurveyActive.addClass('product-survey-field-error');
        }
      } else if ( $hbFormSurveyActive.find('input').length ) {
        if ( $hbFormSurveyActive.find('input').val() != "" ) {
          console.log("input box found. Showing Next");
          $hbFormSurveyActive.hide();
          $hbFormSurveyActive.removeClass('product-survey-field-error');
          nextSurveyField.show().addClass('activeHSField');
          $currentHBFormSurvey.removeClass('activeHSField');
          $('.product-survey-inner').addClass('step-'+( $activeHSFieldIndex + 1 ) );
        } else {
          console.log("input box error");
          $hbFormSurveyActive.addClass('product-survey-field-error');
        }
      }
      checkSurveyFldMakeActiveNext();
    } else {
        if ($('.product-survey input[name=email]').length < 1) {
          $('.product-survey input[type=submit]').click();
        } else if ( validateEmailMC($('.product-survey input[name=email]').val()) ) {
            $('.product-survey input[type=submit]').click();
        } else {
            $('.product-survey input[name=email]').closest('.hs-form-field').addClass('product-survey-field-error');
        }
        console.log("Validate and Submit the form");
    }

  });
    
  /* Handle clicks on the Getting Started Survey's previous button */
  $('.product-survey-previous').click(function() {

    var $activeHSFieldIndex = $('.product-survey div.hs-form-field').index($('.activeHSField'));
    if ($activeHSFieldIndex < 1) {
      return false
    }
    if ($(this).hasClass('disabledSurBtn')) {
      return false;
    }

    $('.product-survey-next').removeClass('next-active-state');

    var $currentHBFormSurvey =  $('.product-survey div.hs-form-field:eq('+$activeHSFieldIndex+')');
    var $hbFormSurveyActive = $('.product-survey div.hs-form-field.activeHSField');
    var $hbFormSurvey = $('.product-survey div.hs-form-field');
    var $parentDependantField = $hbFormSurveyActive.closest('.hs-dependent-field');
    var formFieldWrapper = $hbFormSurveyActive;
    var prevSurveyField = $('.product-survey div.hs-form-field:not(.hs_form_submission_domain):eq('+($activeHSFieldIndex-1)+')');
    
    console.log("Active Index"+$activeHSFieldIndex);

    if ($activeHSFieldIndex ==1 &&  $('.product-survey-inner .hs_brand_custom').length < 1) {
        $('.product-survey-inner').removeClass('step-2').removeClass('step-1');
    }
    if ($activeHSFieldIndex > 1 &&  $('.product-survey-inner .hs_brand_custom').length < 1) {
        $activeHSFieldIndex = $activeHSFieldIndex + 1;
    }
    if ( prevSurveyField.length) {
        console.log("Showing Previous");
        $hbFormSurveyActive.hide();
        prevSurveyField.show().addClass('activeHSField');
        $currentHBFormSurvey.removeClass('activeHSField');
        $('.product-survey-inner').removeClass('step-'+$activeHSFieldIndex).addClass('step-'+( $activeHSFieldIndex - 1 ));

      checkSurveyFldMakeActiveNext();
    } else {
      console.log("No Previous field");
      $('.product-survey-get-started').show();
      $('.product-survery-hb-form').hide();
      $('.product-survey-inner').removeClass('step-0');
      $('.product-survey div.hs-form-field:eq(0)').removeClass('activeHSField');
      checkSurveyFldMakeActiveNext();
    }
  });

  $('body').on('change','.product-survery-hb-form select, .product-survery-hb-form input', function() {
    var isValidFld = true;
    if ($(this).attr('type') != 'undefined' && $(this).attr('type') == 'email') {
      if (!validateEmailMC($(this).val())) {
        isValidFld = false;
      }
    }
    if ($(this).val() != '' && isValidFld == true) {
      $('.product-survey-next').addClass('next-active-state');
    } else {
      $('.product-survey-next').removeClass('next-active-state');
    }
  });
  
  $('.start-product-survey').click(function() {
    $('.product-survey-get-started').hide();
    $('.product-survery-hb-form').show();
    $('.product-survey-inner').addClass('step-0');
    $('.product-survey div.hs-form-field:eq(0)').addClass('activeHSField');

    if ($('.product-survey div.hs-form-field:eq(0) select option:selected').val() != '') {
      $('.product-survey-next').addClass('next-active-state');
    }

    var $target_budget_div = $('.product-survey input[name="total_budget"]').closest('div');
    if (!$target_budget_div.hasClass('target-buget-dollar-div')) {
      $target_budget_div.addClass('target-buget-dollar-div').prepend('$ ');
    }
  });
    
  /* Handle submissions of the Getting Started Survey */
  $('.product-survey').on('hsvalidatedsubmit', '.hs-form', function (e) {

    var ps_looking_for = $('.product-survey select[name=what_are_you_looking_for] option:selected').val().replace(" ","-");
    var ps_email = $('.product-survey input[name=email]').val();
    var ps_color = $('.product-survey select[name=color] option:selected').val();
    var ps_total_budget = $('.product-survey input[name=total_budget]').val();
    var ps_total_product = $('.product-survey input[name=potential_order_quantity_from_survey]').val();
    var ps_brand = ($('.product-survey .hs_brand_custom select option:selected').length) ? $('.product-survey .hs_brand_custom select option:selected').val().replace(" ","-") : '';
    var redirectUri = new Array();

    if ( ps_looking_for != "Headwear" && ps_looking_for != "Stationery"  ) {
      if (ps_looking_for != '' && ps_looking_for.toLowerCase() != 'no preference' && ps_looking_for.toLowerCase() != 'no-preference') {
        redirectUri.push(ps_looking_for.toLowerCase());
      }
    }

    if ( typeof ps_color != "undefined" && ps_looking_for != "Electronics" ) {
      if (ps_color != '' && ps_color.toLowerCase() != 'no preference' && ps_color.toLowerCase() != 'no-preference') {
        redirectUri.push("filter"+ps_color.toLowerCase());
      }
    }
    
    // Determine which collection to send the customer to
    if ( ps_looking_for == "Headwear" ) {
      ps_redirect_to_link = "/collections/custom-recommendations-headwear/";
    } else if( ps_looking_for == "Stationery" ) {
      ps_redirect_to_link = "/collections/custom-recommendations-stationery/";
    } else {
      var average_budget = ps_total_budget / ps_total_product;
      var ps_redirect_to_link = "/collections";

      if ( average_budget >= 0 && average_budget <= 30 )
          ps_redirect_to_link += "/budget-0-30-item/";
      else if ( average_budget >= 30 && average_budget <= 60 )
          ps_redirect_to_link += "/budget-30-60-item/";
      else if ( average_budget >= 60 && average_budget <= 90 )
          ps_redirect_to_link += "/budget-60-90-item/";
      else if ( average_budget >= 90 && average_budget <= 120 )
          ps_redirect_to_link += "/budget-90-120-item/";
      else if ( average_budget >= 120 )
          ps_redirect_to_link += "/budget-120-item/";
    }

    if (ps_brand != '' && ps_brand.toLowerCase() != 'no preference' && ps_brand.toLowerCase() != 'no-preference') {
      redirectUri.push(ps_brand.toLowerCase());
    }

    ps_redirect_to_link += redirectUri.join('+');
    ps_redirect_to_link += "?result=1";

    $('.product-survey-previous,.product-survey-next').addClass('disabledSurBtn');

    setTimeout(function(){ window.location.href = ps_redirect_to_link; }, 2500);

  });

  $('.product-survey').on('change','select',function() {
    $(this).closest('.hs-form-field').removeClass('product-survey-field-error');
    if ($(this).closest('.hs_what_are_you_looking_for').length) {
      var lookingForSec = $(this).closest('.hs_what_are_you_looking_for');
      lookingForSec.next('.hs-form-field').addClass('hs_brand_custom');
    }
  });

  $('.product-survey').on('keyup keypress','input',function() {
    var inputHSValue = $(this).val();
    var inputHSName = $(this).attr('name');
    if ( typeof inputHSValue != "undefined" && inputHSValue.trim() != "" ) {
        if ( inputHSName == "email" ) {
            if ( validateEmailMC(inputHSValue) ) {
              $(this).closest('.hs-form-field').removeClass('product-survey-field-error');
              $(this).closest('.hs-form-field').addClass('product-survey-correct-email');
            } else
              $(this).closest('.hs-form-field').removeClass('product-survey-correct-email');
        } else
          $(this).closest('.hs-form-field').removeClass('product-survey-field-error');
    } else {
      $(this).closest('.hs-form-field').addClass('product-survey-field-error');
      $(this).closest('.hs-form-field').removeClass('product-survey-correct-email');
    }
  });
  
    //product detail accordion options
    $('.accord-head').on('click', function(event) {
          event.preventDefault();
  
          if($(this).hasClass('accord-disabled')) {
            return false;
          }
          // create accordion variables
          var accordion = $(this);
          var accordionContent = accordion.next('.accord-content');
  
          // toggle accordion link open class
          if (accordion.hasClass("open")) {
              accordion.removeClass("open");
          } else {
            accordion.addClass("open");
          }
  
          // toggle accordion content
          accordionContent.slideToggle(500);
  
     });
    $('.shappify_option_value input[type=radio]').on('change', function() {

      $(this).closest('.shappify_option_value').find('[name="'+ this.name +'"]').each(function(index, item) {
        $(item).parent().removeClass('radioClicked');
      })
      $(this).parent().addClass('radioClicked');

      if (this.name == 'properties[Add second logo ?]' && !$('[name="properties[Second logo decoration type]"]:checked').parent().hasClass('radioClicked')) {
        $('[name="properties[Second logo decoration type]"]:checked').parent().addClass('radioClicked');
      }
    });

    $('.customize-accord  input[type=checkbox]').on('change',function() {
        if ($(this).is(":checked")) {
          $(this).closest('.shappify_checkbox_option').addClass('checkboxClicked');
        } else {
          $(this).closest('.shappify_checkbox_option').removeClass('checkboxClicked');
        }
    });
  
    $('.customize-accord  input[type=number], .customize-accord  input[type=text]').on('change',function() {
        if ($(this).val() != '' && $(this).val() != '0') {
          $(this).closest('.shappify_input_option').addClass('inputClicked');
        } else {
          $(this).closest('.shappify_input_option').removeClass('inputClicked');
        }
    });

    // Handle keyboard quantities value changes
    $('input[name="smallQty"]').on('change', function(event) {
      if(isSampleOrder) {
        const newValue = $(this).val();
        if (newValue > 1) {
          $(this).val(1);
        }
      }
    });
  
     // Handle user changes to decoration type
     $('input[name="properties[Decoration type]"]').on('change', function(event) {
        if ($('input[name="properties[Decoration type]"]:checked').length > 0 && $('input[name="properties[Decoration type]"]:checked').val() != 'Sample') {
            // User selected a decoration type other than "Sample"
            setSampleOrder(false);

            // Automatically select the first decoration location
            $('input[name="properties[Select decoration location]"]:first').prop('checked','checked').trigger('change');

            // Open and enable the section 02 CHOOSE DECORATION LOCATION
            $('.accord-sr-2 .accord-head').next('.accord-content').slideDown(500);
            $('.accord-sr-2 .accord-head').removeClass('accord-disabled').addClass('open');
            $('.accord-sr-4 .accord-head').removeClass('accord-disabled'); // Enable section 04 OPTIONAL EXTRAS

            if ($('input[name="properties[Decoration type]"]:checked').val() == 'Embroidered') {
              $('[name="properties[Second logo decoration type]"]').attr('disabled', 'true');
              $('#add_color').slideUp(500);
            } else {
              $('[name="properties[Second logo decoration type]"]').removeAttr('disabled');
              $('#add_color').slideDown(500);
            }
  
        } else {
            // User selected "Sample" for decoration type, so hide decoration location, logo, and optional extras sections
            setSampleOrder(true);

            $('.accord-sr-2 .accord-head').next('.accord-content').slideUp(500);
            $('.accord-sr-2 .accord-head').addClass('accord-disabled').removeClass('open');
            $('.accord-sr-4 .accord-head').next('.accord-content').slideUp(500);
            $('.accord-sr-4 .accord-head').addClass('accord-disabled').removeClass('open');
  
            if ($('input[name="properties[Select decoration location]"]:checked').length) {
              $('input[name="properties[Select decoration location]"]:checked').removeAttr('checked').trigger('change');
            }
            resetRadioSec($('.accord-sr-2 .accord-head').next('.accord-content'));
  
        }
     });
  
      // Handle user changes to decoration location
      $('input[name="properties[Select decoration location]"]').on('change', function(event) {
  
        if ($('input[name="properties[Select decoration location]"]:checked').length > 0) {
              // There is a decoration location selected
              if ($('.first_logo input[name="properties[Add embroidered logo ?]"][data-checked="checked"]').length > 0) {
                // Switch the logo option to the same value of the last item added to the cart
                $('.first_logo input[name="properties[Add embroidered logo ?]"][data-checked="checked"]').prop('checked','checked').trigger('change');
              } else {
                // Default to the first logo option
                $('.first_logo input[name="properties[Add embroidered logo ?]"]:first').prop('checked','checked').trigger('change');
              }

              // Open and enable section 03 CHOOSE YOUR LOGO (keep hidden for Sample orders)
              if (!isSampleOrder) {
                $('.accord-sr-3 .accord-head').next('.accord-content').slideDown(500);
                $('.accord-sr-3 .accord-head').removeClass('accord-disabled').addClass('open');
              }
  
        } else {
              // No decoration location selected
              // Close and disable section 03 CHOOSE YOUR LOGO
              $('.accord-sr-3 .accord-head').next('.accord-content').slideUp(500);
              $('.accord-sr-3 .accord-head').addClass('accord-disabled').removeClass('open');
  
              if ($('.first_logo input[name="properties[Add embroidered logo ?]"]:checked').length) {
                // Remove the selected logo option
                var checkedAddLogo  = $('.first_logo input[name="properties[Add embroidered logo ?]"]:checked');
                checkedAddLogo.removeAttr('checked');
              }
  
              resetRadioSec($('.accord-sr-3 .accord-head').next('.accord-content'));
        }
     });

  
    $('.first_logo input[name="properties[Add embroidered logo ?]"]').on('change', function(event){
        if ($('.first_logo input[name="properties[Add embroidered logo ?]"]:checked').length && $('.first_logo input[name="properties[Add embroidered logo ?]"]:checked').val() == 'Yes') {
              showLogoUploadFile(true);
  
        } else if (this.className.indexOf("second_logo_on_file") === -1 && this.className.indexOf("add_second_logo_later") === -1 ) {
             showLogoUploadFile(false);
        }
     });
  
  $('input[type="file"][name="properties[Upload your logo (2MB max)]"]').on('change', function(event) {
      setPreviewUploadImage(this);
  });
  
  $('.main-uploadlogo-container .uploaded-img-editlink').on('click',function() {
    showLogoFileBrowse();
  })
  
  $('.main-uploadlogo-container .upload-img-cancel-edit').on('click',function() {
    cancelEditUploadImg();
  })
  
     $('.js-add-second-logo').on('change', function(event) {
       
        if ($(this).is(":checked")) {
            $('.second-logo-container').show();
            if ($('.second_logo_upload:checked').length > 0) {
              $('.second_logo_upload').prop('checked','checked').trigger('change');
            }
            if ($('.second_logo_upload:checked').length < 1) {
             $('.second_logo_upload').prop("checked",true).trigger("change"); 
            }
        } else {
            $('.second-logo-container').hide();
            if($('.second_logo_upload:checked').length){
              var checkedSecondAddLogo  = $('.second_logo_upload:checked');
                checkedSecondAddLogo.removeAttr('checked');
                checkedSecondAddLogo.trigger('change');
            }
          }
     });
    
  $('.second_logo_upload').on('change', function(event) {
      if ($('.second_logo_upload:checked').length>0 && $('.second_logo_upload:checked').val() == 'Yes') {
          add_showLogoUploadFile(true);
      } else {
          add_showLogoUploadFile(false);
      }  
  });
      
      $('.second_logo_on_file').on('change', function(event) {
          add_showLogoUploadFile(false);
      });
      $('.add_second_logo_later').on('change', function(event) {
          add_showLogoUploadFile(false);
      });
      $('input[type="file"][name="properties[Upload second logo]"]').on('change', function(event) {
          add_setPreviewUploadImage(this);
      });
      $('.additional-uploadlogo-container .uploaded-img-editlink').on('click',function(){
          add_showLogoFileBrowse();
      })
      $('.additional-uploadlogo-container .upload-img-cancel-edit').on('click',function(){
          add_cancelEditUploadImg();
      })

    selectDefaultDecoType();
    selectDefaultSizeForGoogle();
  
     // Show more than 1 screen print color
    $('.need-morethan-1screen').on('click',function() {
        var targetCls = $(this).attr('data-targetclass');
        $(this).parent('.need-morethan-1screen-div').hide();
        $('.'+targetCls).slideDown(500);
    });
    $('.need-morethan-2screen').on('click',function() {
      var targetCls = $(this).attr('data-targetclass');
      $(this).parent('.need-morethan-2screen-div').hide();
      $('.'+targetCls).slideDown(500);
  });
    // Registration Empty Field Check
  $('form#create_customer').submit(function(){
    var regFirstName = $(this).find("input[name='customer[first_name]']").val();
    var regLastName = $(this).find("input[name='customer[last_name]']").val();
    var regCompany = $(this).find("input[name='customer[note][Company]']").val();
    var regEmail = $(this).find("input[name='customer[email]']").val();
    var regPassword = $(this).find("input[name='customer[password]']").val();
    var regErrorFlag = 0;
  
    if ( regFirstName.isEmpty() ) {
      regErrorFlag = 1;
      $(this).find("input[name='customer[first_name]']").closest('.form-group').addClass('form-has-error');
    } else
      $(this).find("input[name='customer[first_name]']").closest('.form-group').removeClass('form-has-error');
  
    if ( regLastName.isEmpty() ) {
      regErrorFlag = 1;
      $(this).find("input[name='customer[last_name]']").closest('.form-group').addClass('form-has-error');
    } else
      $(this).find("input[name='customer[last_name]']").closest('.form-group').removeClass('form-has-error');
  
    if ( regEmail.isEmpty() ) {
      regErrorFlag = 1;
      $(this).find("input[name='customer[email]']").closest('.form-group').addClass('form-has-error');
    } else
      $(this).find("input[name='customer[email]']").closest('.form-group').removeClass('form-has-error');
  
    if ( regPassword.isEmpty() ) {
      regErrorFlag = 1;
      $(this).find("input[name='customer[password]']").closest('.form-group').addClass('form-has-error');
    } else
      $(this).find("input[name='customer[password]']").closest('.form-group').removeClass('form-has-error');
  
    if( regErrorFlag == 1 ) return false;
  });
  
  // Register form : On change error add or remove
  $('body').on('keyup keydown','form#create_customer input',function() {
    var $input = $(this);
    setTimeout(function(){
        if ( $input.attr('name') != "customer[note][Company]" ) {
          if ( $input.val().isEmpty() ) {
              //console.log("IF");
              $input.closest('.form-group').addClass('form-has-error');
          } else {
              //console.log("else");
              $input.closest('.form-group').removeClass('form-has-error');
          }
        }
      },200);
  });
  
  // Phone number validation for special characters and other chratacters ( Contact Us Page )
  $("body").on('keydown',"input[name='phone']",function (e) {
    //console.log(e.keyCode);
      // Allow: backspace, delete, tab, escape, enter and plus sign .
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190, 107]) !== -1 ||
           // Allow: Ctrl+A, Command+A
          (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
           // Allow: home, end, left, right, down, up
          (e.keyCode >= 35 && e.keyCode <= 40)) {
               // let it happen, don't do anything
               return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
      }
  });
  
  // Remove checked checkbox and image field on product optional extras
  $('body').on('click','input[name="properties[Decoration type]"]',function(){
    if( $(this).attr('value') == "Sample" ) {
          $('input[type="file"][name="properties[Upload second logo]"]').val('');
          $('form#bold-form-options div.customize-accord:last input[type=checkbox]').each(function(){
              //console.log($(this).attr('name'));
              var $thisCheckbox = $(this);
              if( $thisCheckbox.closest('.shappify_checkbox_option').hasClass('checkboxClicked') )
                  $thisCheckbox.closest('.shappify_checkbox_option').trigger('click');
  
          });
    }
  });
  selectDefaultLogoOption();
});

// Save url to cookie on click
$('.product-upload-logo').click(function() {
  createCookie('product_url_for_logo', $(this).attr('data-save'), 1);
  createCookie('product_logo_replacement', $(this).attr('data-logo-placement'), 1);
});

function initSlick() {
  if ($('.heroSlider').length > 0) {
      $('.heroSlider').slick({
          prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
          nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
          swipeToSlide: true,
          dots: true,
          autoplay: true,
          infinite: true,
          autoplaySpeed: 5000,
          adaptiveHeight: true 
      });
  }

  if ($('.heroSlider-ua').length > 0) {
      $('.heroSlider-ua').slick({
          prevArrow: false,
          nextArrow: false,
          swipeToSlide: false,
          dots: false,
          autoplay: false,
          infinite: false,
          autoplaySpeed: 3000,
          adaptiveHeight: true,
          touchMove: false,
          swipe: false
      });
  }

  if ($('.offerSlider').length > 0) {
      $('.offerSlider').slick({
          dots: false,
          infinite: false,
          swipeToSlide: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
          nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
          responsive: [
              {
                  breakpoint: 767,
                  swipeToSlide: true,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                  }
              }

          ]
      });
  }

  if ($('.colorChoiceSlider').length > 0) {
      $('.colorChoiceSlider').slick({
          slidesToShow: 7,
          slidesToScroll: 7,
          speed: 200,
          swipeToSlide: false,
          infinite:false,
          prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
          nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
          focusOnSelect: true,
          responsive: [
              {
                  breakpoint: 767,
                  settings: {
                      swipeToSlide: false,
                      arrows:false,
                      slidesToShow: 6,
                      slidesToScroll: 6
                  }
              }

          ]
      });
  }

  if ($('.product').length > 0) {
      $('.product').slick({
        swipeToSlide: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        //fade: true,
        prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
        nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
        asNavFor: '.product-nav'
      });
  }

  if ($('.product-nav').length > 0) {
    $('.product-nav').slick({
      swipeToSlide: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product',
      dots: false,
      arrows: false,
      prevArrow: "<span class='arrow_carrot-left prevArrow'></span>",
      nextArrow: "<span class='arrow_carrot-right nextArrow'></span>",
      focusOnSelect: true
    });
  }
} //END function initSlick()

function bodyTopPadding() {
  headerHeight = $('header.header').outerHeight();
  if( $(window).width() <= 767 ) {
    $('body').css({'padding-top':headerHeight});
  } else {
    $('body').css({'padding-top':0});
  }
}


// This function will open a modal on any page by simply including the modal's ID in the "show_modal" URL parameter
// For example, "?show_modal=getLogoMockupModal" would open the modal with id="getLogoMockupModal"
// @Noerbot5000
function openModalFromUrlParameter() {
  if(getParameterByName("show_modal") != ''){
    var modalToOpen = "#" + getParameterByName("show_modal");
    $(modalToOpen).modal('show');
  }
}

function getFocus() {
    document.getElementById("footer-search-textinput").focus();
}
// Subscribe MailChimp

$.fn.hasExtension = function(exts) {
    return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$', 'ig')).test($(this).val());
}

function validateEmailMC(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

String.prototype.isEmpty = function() {
    return (this.length === 0 || !this.trim());
};

function subscribeMC() {
  //return false;
 var subEmailMC = $('#subscribeMailChimpExclusive').val();

 $('.subscribeMailChimpErr').html('');
 if( validateEmailMC(subEmailMC) )
 {
   $('.subscribeMailChimpLoader').show();
   $.ajax({
     type: 'POST',
     url: 'https://rangempls.com/merchology/subscribe.php',
     data: {'MERGE0':  subEmailMC },
     success: function(data) {
       $('.subscribeMailChimpLoader').hide();
       $('#subscribeMailChimpExclusive').val('');
       $('.subscribeMailChimpErr').html(data);
     },
     error: function(XMLHttpRequest, textStatus) {
       $('.subscribeMailChimpLoader').hide();
       $('.subscribeMailChimpErr').html('<p class="error">Something is wrong.Please try again!</p>');
     }
   });
 }
 else
 {
   $('.subscribeMailChimpErr').html('<p class="error">Please enter valid email address!</p>');
 }
}


/* Create Cookie - this function can be used to create a cookie! */
function createCookie(name, value, days) {
    var date, expires;
    if (days) {
        date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name+"="+value+expires+"; path=/";
}

function share_fb(url) {
  window.open('https://www.facebook.com/sharer/sharer.php?u='+url,'facebook-share-dialog',"width=626,height=436")
}

function equalheight(container) {
    var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el;
     
    $(container).each(function() {

       $el = $(this);
       $($el).height('auto');
       var topPosition = $el.position().top;

       if (currentRowStart != topPosition) {
         for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
           rowDivs[currentDiv].height(currentTallest);
         }
         rowDivs.length = 0; // empty the array
         currentRowStart = topPosition;
         currentTallest = $el.height();
         rowDivs.push($el);
       } else {
         rowDivs.push($el);
         currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
       }
       
       for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
         rowDivs[currentDiv].height(currentTallest);
       }

    });
}

function hardEqualHeights(container){
  var max_height = 0;
    $(container).height('auto');
  $(container).each(function(){
    max_height = Math.max($(this).height(), max_height);
  });
  $(container).each(function(){
    $(this).height(max_height);
  });
}

function countHeights() {
  winHeight = $(window).height();
  winWidth = $(window).width();
}

var shortHeight = function() {
    countHeights();
    $('#sort-by-list, .select-attrs').css({'max-height':winHeight-95})
}

var tabHeights = function() {
    countHeights();
    $('#details, #delivery, .productReview ').css({'max-height':winHeight})
}


function setFooterAutoPos () {
  if (typeof $jquery.fn.autocomplete != 'undefined') {
    $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete("widget").addClass("footer_ui_complete").removeClass("ui_fixed_height");
    $jquery( ".header .ui-autocomplete-input:first" ).autocomplete("widget").addClass("header_ui_complete");

    if($(window).width() < 768) {
      $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete( "option", "position", { my: "left top", at: "left bottom", collision: "none" });
    } else if ($(window).width() >= 768 && $(window).width() < 982) {
      $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete("widget").addClass("ui_fixed_height");
      $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete( "option", "position", {my:"right bottom-80",at:"right+80 bottom",collision:"none"});
    } else {
      $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete("widget").addClass("ui_fixed_height");
      $jquery( ".form-sec-footer .ui-autocomplete-input:first" ).autocomplete( "option", "position", {my:"left-25 bottom-80",at:"left bottom",collision:"none"});
    }
  }
}

function checkSurveyFldMakeActiveNext() {
  if ($('.product-survery-hb-form input:visible').length > 0) {
    var inpType = $('.product-survery-hb-form input:visible').attr('type');
    var inpVal = $('.product-survery-hb-form input:visible').val();
    if (inpType == 'email') {
      if ( inpVal != '' && validateEmailMC(inpVal)) {
        $('.product-survey-next').addClass('next-active-state');
      } else {
        $('.product-survey-next').removeClass('next-active-state');
      }
    } else if (inpVal != '') {
      $('.product-survey-next').addClass('next-active-state');
    } else {
      $('.product-survey-next').removeClass('next-active-state');
    }
  } else if ($('.product-survery-hb-form select:visible').length > 0) {
    if ($('.product-survery-hb-form select:visible option:selected').val() != '') {
      $('.product-survey-next').addClass('next-active-state');
    } else {
      $('.product-survey-next').removeClass('next-active-state');
    }
  }
}

  /***** start - product option disable enable accordion ********/
function resetRadioSec(tempSec) {
    tempSec.find('.shappify_radio_option').removeClass('radioClicked');
}

function showLogoUploadFile(flgVal) {
  if (flgVal == true) {
    $('.main-uploadlogo-container').show();
  } else {
    $('.main-uploadlogo-container').hide();
  }
}

function showLogoFileBrowse() {
  $('.main-uploadlogo-container').removeClass('photo-exists').show();
}

function cancelEditUploadImg() {
  $('.main-uploadlogo-container').addClass('photo-exists');
}

function setPreviewUploadImage(input) {
  var preview = document.getElementById('preview_uploaded_file');
  if (input.files && input.files[0]) {
    
    if(typeof($.fn.hasExtension) == 'undefined') { 
      $.fn.hasExtension = function(exts) {
          return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$', 'ig')).test($(this).val());
      }
    }
    
    if (!$(input).hasExtension(['.jpg','.jpeg','.png', '.gif'])) {
      $('.main-uploadlogo-container').addClass('invalid-file-error');
      $('.upload-logo-invalid-error').show();
    } else {
      $('.upload-logo-invalid-error').hide();
      $('.main-uploadlogo-container').removeClass('invalid-file-error');
      var reader = new FileReader();
      reader.onload = function (e) {
        preview.setAttribute('src', e.target.result);
        $('.main-uploadlogo-container').addClass('photo-exists').attr('data-photo',true);
      }
      reader.readAsDataURL(input.files[0]);
      var tempUfileName = (input.files[0].name.length > 30) ? input.files[0].name.substring(0,30) + '...' : input.files[0].name;
      $('.main-uploadlogo-container .uploaded-img-name').text(tempUfileName);
      $('#hidden_upload_your_logo_name').val('');
    }

  } else {
    //preview.setAttribute('src', 'placeholder.png');
    $('.upload-logo-invalid-error').hide();
    $('.main-uploadlogo-container').removeClass('invalid-file-error');
    $('.main-uploadlogo-container').removeClass('photo-exists').attr('data-photo',false);
  }
}

// additional logo -start
function add_showLogoUploadFile(flgVal) {
  if (flgVal == true) {
    $('.additional-uploadlogo-container').show();
  } else {
    $('.additional-uploadlogo-container').hide();
  }
}

function add_showLogoFileBrowse() {
  $('.additional-uploadlogo-container').removeClass('photo-exists').show();
}

function add_cancelEditUploadImg() {
  $('.additional-uploadlogo-container').addClass('photo-exists');
}

function add_setPreviewUploadImage(input) {
    var preview = document.getElementById('preview_additional_uploaded_file');

  if (input.files && input.files[0]) {
      if (typeof($.fn.hasExtension) == 'undefined') {
        $.fn.hasExtension = function(exts) {
            return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$', 'ig')).test($(this).val());
        }
      }
      if (!$(input).hasExtension(['.jpg', '.jpeg', '.png', '.gif'])) {
          $('.upload-logo-second-invalid-error').show();
          $('.additional-uploadlogo-container').addClass('invalid-file-error');
      } else {
          $('.upload-logo-second-invalid-error').hide();
          $('.additional-uploadlogo-container').removeClass('invalid-file-error');
          var reader = new FileReader();
          reader.onload = function (e) {
            preview.setAttribute('src', e.target.result);
            $('.additional-uploadlogo-container').addClass('photo-exists').attr('data-photo',true);
          }
          reader.readAsDataURL(input.files[0]);

          var tempUfileName = (input.files[0].name.length > 30) ? input.files[0].name.substring(0,30) + '...' : input.files[0].name;
          $('.additional-uploadlogo-container .uploaded-img-name').text(tempUfileName);

          $('#hidden_additional_second_logo_name').val('');
      }
  } else {
    $('.upload-logo-second-invalid-error').hide();
      $('.additional-uploadlogo-container').removeClass('invalid-file-error');
    //preview.setAttribute('src', 'placeholder.png');
    $('.additional-uploadlogo-container').removeClass('photo-exists').attr('data-photo',false);
  }
}
// additional logo - end

//tooltip delay
function delayToolTip() {
  if (typeof($.fn.tooltip) != 'undefined') {
    if (typeof($.fn.tooltip.Constructor) != 'undefined') {
      originalLeave = $.fn.tooltip.Constructor.prototype.leave;
      $.fn.tooltip.Constructor.prototype.leave = function(obj) {
        var self = obj instanceof this.constructor ? obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type)
        var container, timeout;

        originalLeave.call(this, obj);

        if (obj.currentTarget) {
          container = $(obj.currentTarget).siblings('.tooltip')
          timeout = self.timeout;
          container.one('mouseenter', function() {
            //We entered the actual popover – call off the dogs
            clearTimeout(timeout);
            //Let's monitor popover content instead
            container.one('mouseleave', function() {
              $.fn.tooltip.Constructor.prototype.leave.call(self, self);
            });
          })
        }
      };
    }
  }
}

/**
 * isOnCompanyCartPage boolean - set true when called from the page.company-store.cart template
 * get and set cookie that contains a time of updating company cart to reduce redirects
 */
function updateCompanyCartCookie(isOnCompanyCartPage) {
  var cookieName = 'companyCartUpdated',
    cookieValue = new Date().getTime(),
    timeInMillisecondsFromCookie = getCookie(cookieName);
  if (cookieValue - timeInMillisecondsFromCookie < 45000) {
    return false;
  } else {
    setCookie(cookieName, cookieValue, 1);
    if (isOnCompanyCartPage != true) {
      window.location.href = '/pages/company-cart';
    }
  }
}

// Determine the default for decoration type and select it
function selectDefaultDecoType() {
  if (window.location.search.indexOf('gshopping=true') > -1) {
    // Default Google Shopping visitors to 'Sample' (the last decoration type)
    $('input[name="properties[Decoration type]"]:last').prop("checked", true).change();
  } else {
    // Default to the first decoration type
    $('input[name="properties[Decoration type]"]:first').prop("checked", true).change();
  }
}

// Selects the first available size if gshopping URL param is found
function selectDefaultSizeForGoogle(){
  if (window.location.search.indexOf('gshopping=true') > -1 && $('.ProductSizeInfo.selected').length == 0) {
    $('.ProductSizeInfo:not(.outOfStock)').first().find('.buttnQtyChange.arrow_triangle-up').click()
  }
}


//Select logo option by default if logo already saved
function selectDefaultLogoOption(){
  var savedLogo = false;
  if(typeof LMTAQA != 'undefined'){
    savedLogo = LMTAQA.getLogoFromStorage();
  }
    if(savedLogo && typeof(savedLogo.isLogoOnFile) != 'undefined' && savedLogo.isLogoOnFile === true){
      $('input[name="properties[Add embroidered logo ?]"][value="Logo on file"]').prop("checked", true).change();
    }else{
      $('input[name="properties[Add embroidered logo ?]"][value="Yes"]').prop("checked", true).change();
    }
}

// This function sets equal heights for all jquery selectors listed below.
// It will apply equal height to them on page load and on window resize.
function setAllEqualHeights(){
  var selectors = [
    '.offer-slide-box .custom-table .table-cell',
  ];
  selectors.forEach(function(selector){
    hardEqualHeights(selector);
  });
  $(window).resize(function(){
    selectors.forEach(function(selector){
      hardEqualHeights(selector);
    });
  });
}

// This function set the order to Sample and force max qty to 1
function setSampleOrder(isSample) {
  isSampleOrder = isSample;
  if(isSampleOrder) {
    $('.sample-order-disclaimer').show();
    $('input[name=smallQty]').each(function() {
      if(parseInt($(this).val()) > 1) {
        $(this).val(1);
      }
    })
  }
  else {
    $('.sample-order-disclaimer').hide();
  }
}